"use strict";

/*! dprd-semantic-analytics-framework - v5.0.10 - 2018-07-26 */
(function (window, document, location, undefined) {
  /*! analytics - v6.1.4-0 - 2018-07-23 */
  (function () {
    /* eslint-disable */
    !function e(t, i, n) {
      function r(s, o) {
        if (!i[s]) {
          if (!t[s]) {
            var l = "function" == typeof require && require;if (!o && l) return l(s, !0);if (a) return a(s, !0);var u = new Error("Cannot find module '" + s + "'");throw u.code = "MODULE_NOT_FOUND", u;
          }var d = i[s] = { exports: {} };t[s][0].call(d.exports, function (e) {
            var i = t[s][1][e];return r(i ? i : e);
          }, d, d.exports, e, t, i, n);
        }return i[s].exports;
      }for (var a = "function" == typeof require && require, s = 0; s < n.length; s++) {
        r(n[s]);
      }return r;
    }({ 1: [function (e, t, i) {
        (function (i) {
          function n() {
            function e() {
              h.windowLoaded = !0;
            }i.addEventListener ? i.addEventListener("load", e) : i.attachEvent && i.attachEvent("onload", e), h.codeLoadEnd = new Date().getTime();
          } /** @license ============== DO NOT ALTER ANYTHING BELOW THIS LINE ! ============
            Adobe Visitor API for JavaScript version: 3.1.2
            Copyright 1996-2015 Adobe, Inc. All Rights Reserved
            More info available at https://marketing.adobe.com/resources/help/en_US/mcvid/
            */
          var r = e("./child/ChildVisitor"),
              a = e("./child/Message"),
              s = e("./child/makeChildMessageListener"),
              o = e("./utils/asyncParallelApply"),
              l = e("./utils/enums"),
              u = e("./utils/utils"),
              d = e("./utils/getDomain"),
              c = e("./units/version"),
              f = e("./units/crossDomain"),
              g = e("@adobe-mcid/visitor-js-shared/lib/ids/generateRandomID"),
              p = e("./units/makeCorsRequest"),
              m = e("./units/makeDestinationPublishing"),
              _ = e("./utils/constants"),
              h = function h(e, t, n) {
            function r(e) {
              var t = e;return function (e) {
                var i = e || v.location.href;try {
                  var n = S._extractParamFromUri(i, t);if (n) return H.parsePipeDelimetedKeyValues(n);
                } catch (e) {}
              };
            }function h(e) {
              function t(e, t) {
                e && e.match(_.VALID_VISITOR_ID_REGEX) && t(e);
              }t(e[k], S.setMarketingCloudVisitorID), S._setFieldExpire(V, -1), t(e[R], S.setAnalyticsVisitorID);
            }function C(e) {
              e = e || {}, S._supplementalDataIDCurrent = e.supplementalDataIDCurrent || "", S._supplementalDataIDCurrentConsumed = e.supplementalDataIDCurrentConsumed || {}, S._supplementalDataIDLast = e.supplementalDataIDLast || "", S._supplementalDataIDLastConsumed = e.supplementalDataIDLastConsumed || {};
            }function D(e) {
              function t(e, t, i) {
                return i = i ? i += "|" : i, i += e + "=" + encodeURIComponent(t);
              }function i(e) {
                var t = H.getTimestampInSeconds();return e = e ? e += "|" : e, e += "TS=" + t;
              }function n(e, i) {
                var n = i[0],
                    r = i[1];return null != r && r !== N && (e = t(n, r, e)), e;
              }var r = e.reduce(n, "");return i(r);
            }function I(e) {
              var t = 20160,
                  i = e.minutesToLive,
                  n = "";return (S.idSyncDisableSyncs || S.disableIdSyncs) && (n = n ? n : "Error: id syncs have been disabled"), "string" == typeof e.dpid && e.dpid.length || (n = n ? n : "Error: config.dpid is empty"), "string" == typeof e.url && e.url.length || (n = n ? n : "Error: config.url is empty"), "undefined" == typeof i ? i = t : (i = parseInt(i, 10), (isNaN(i) || i <= 0) && (n = n ? n : "Error: config.minutesToLive needs to be a positive number")), { error: n, ttl: i };
            }if (!n || n.split("").reverse().join("") !== e) throw new Error("Please use `Visitor.getInstance` to instantiate Visitor.");var S = this;S.version = "3.1.2";var v = i,
                A = v.Visitor;A.version = S.version, A.AuthState = l.AUTH_STATE, A.OptOut = l.OPT_OUT, v.s_c_in || (v.s_c_il = [], v.s_c_in = 0), S._c = "Visitor", S._il = v.s_c_il, S._in = v.s_c_in, S._il[S._in] = S, v.s_c_in++, S._log = { requests: [] }, S.marketingCloudOrgID = e, S.cookieName = "AMCV_" + e, S.sessionCookieName = "AMCVS_" + e, S.cookieDomain = d(), S.cookieDomain === v.location.hostname && (S.cookieDomain = ""), S.loadSSL = v.location.protocol.toLowerCase().indexOf("https") >= 0, S.loadTimeout = 3e4, S.CORSErrors = [], S.marketingCloudServer = S.audienceManagerServer = "dpm.demdex.net", S.sdidParamExpiry = 30;var y = v.document,
                M = null,
                b = "MC",
                k = "MCMID",
                E = "MCORGID",
                T = "MCCIDH",
                O = "MCSYNCSOP",
                w = "MCIDTS",
                L = "MCOPTOUT",
                P = "A",
                R = "MCAID",
                F = "AAM",
                x = "MCAAMLH",
                V = "MCAAMB",
                N = "NONE",
                j = function j(e) {
              return !Object.prototype[e];
            },
                U = p(S, G);S.FIELDS = l.FIELDS, S.cookieRead = function (e) {
              e = encodeURIComponent(e);var t = (";" + y.cookie).split(" ").join(";"),
                  i = t.indexOf(";" + e + "="),
                  n = i < 0 ? i : t.indexOf(";", i + 1),
                  r = i < 0 ? "" : decodeURIComponent(t.substring(i + 2 + e.length, n < 0 ? t.length : n));return r;
            }, S.cookieWrite = function (e, t, i) {
              var n,
                  r = S.cookieLifetime;if (t = "" + t, r = r ? ("" + r).toUpperCase() : "", i && "SESSION" !== r && "NONE" !== r) {
                if (n = "" !== t ? parseInt(r ? r : 0, 10) : -60) i = new Date(), i.setTime(i.getTime() + 1e3 * n);else if (1 === i) {
                  i = new Date();var a = i.getYear();i.setYear(a + 2 + (a < 1900 ? 1900 : 0));
                }
              } else i = 0;return e && "NONE" !== r ? (y.cookie = encodeURIComponent(e) + "=" + encodeURIComponent(t) + "; path=/;" + (i ? " expires=" + i.toGMTString() + ";" : "") + (S.cookieDomain ? " domain=" + S.cookieDomain + ";" : ""), S.cookieRead(e) === t) : 0;
            }, S.resetState = function (e) {
              e ? S._mergeServerState(e) : C();
            }, S._isAllowedDone = !1, S._isAllowedFlag = !1, S.isAllowed = function () {
              return S._isAllowedDone || (S._isAllowedDone = !0, (S.cookieRead(S.cookieName) || S.cookieWrite(S.cookieName, "T", 1)) && (S._isAllowedFlag = !0)), S._isAllowedFlag;
            }, S.setMarketingCloudVisitorID = function (e) {
              S._setMarketingCloudFields(e);
            }, S._use1stPartyMarketingCloudServer = !1, S.getMarketingCloudVisitorID = function (e, t) {
              if (S.isAllowed()) {
                S.marketingCloudServer && S.marketingCloudServer.indexOf(".demdex.net") < 0 && (S._use1stPartyMarketingCloudServer = !0);var i = S._getAudienceManagerURLData("_setMarketingCloudFields"),
                    n = i.url;return S._getRemoteField(k, n, e, t, i);
              }return "";
            }, S.getVisitorValues = function (e, t) {
              var i = { MCMID: { fn: S.getMarketingCloudVisitorID, args: [!0], context: S }, MCOPTOUT: { fn: S.isOptedOut, args: [void 0, !0], context: S }, MCAID: { fn: S.getAnalyticsVisitorID, args: [!0], context: S }, MCAAMLH: { fn: S.getAudienceManagerLocationHint, args: [!0], context: S }, MCAAMB: { fn: S.getAudienceManagerBlob, args: [!0], context: S } },
                  n = t && t.length ? H.pluck(i, t) : i;o(n, e);
            }, S._currentCustomerIDs = {}, S._customerIDsHashChanged = !1, S._newCustomerIDsHash = "", S.setCustomerIDs = function (e) {
              function t() {
                S._customerIDsHashChanged = !1;
              }if (S.isAllowed() && e) {
                S._readVisitor();var i, n;for (i in e) {
                  if (j(i) && (n = e[i])) if ("object" == typeof n) {
                    var r = {};n.id && (r.id = n.id), void 0 != n.authState && (r.authState = n.authState), S._currentCustomerIDs[i] = r;
                  } else S._currentCustomerIDs[i] = { id: n };
                }var a = S.getCustomerIDs(),
                    s = S._getField(T),
                    o = "";s || (s = 0);for (i in a) {
                  j(i) && (n = a[i], o += (o ? "|" : "") + i + "|" + (n.id ? n.id : "") + (n.authState ? n.authState : ""));
                }S._newCustomerIDsHash = S._hash(o), S._newCustomerIDsHash !== s && (S._customerIDsHashChanged = !0, S._mapCustomerIDs(t));
              }
            }, S.getCustomerIDs = function () {
              S._readVisitor();var e,
                  t,
                  i = {};for (e in S._currentCustomerIDs) {
                j(e) && (t = S._currentCustomerIDs[e], i[e] || (i[e] = {}), t.id && (i[e].id = t.id), void 0 != t.authState ? i[e].authState = t.authState : i[e].authState = A.AuthState.UNKNOWN);
              }return i;
            }, S.setAnalyticsVisitorID = function (e) {
              S._setAnalyticsFields(e);
            }, S.getAnalyticsVisitorID = function (e, t, i) {
              if (!H.isTrackingServerPopulated() && !i) return S._callCallback(e, [""]), "";if (S.isAllowed()) {
                var n = "";if (i || (n = S.getMarketingCloudVisitorID(function (t) {
                  S.getAnalyticsVisitorID(e, !0);
                })), n || i) {
                  var r = i ? S.marketingCloudServer : S.trackingServer,
                      a = "";S.loadSSL && (i ? S.marketingCloudServerSecure && (r = S.marketingCloudServerSecure) : S.trackingServerSecure && (r = S.trackingServerSecure));var s = {};if (r) {
                    var o = "http" + (S.loadSSL ? "s" : "") + "://" + r + "/id",
                        l = "d_visid_ver=" + S.version + "&mcorgid=" + encodeURIComponent(S.marketingCloudOrgID) + (n ? "&mid=" + encodeURIComponent(n) : "") + (S.idSyncDisable3rdPartySyncing || S.disableThirdPartyCookies ? "&d_coppa=true" : ""),
                        u = ["s_c_il", S._in, "_set" + (i ? "MarketingCloud" : "Analytics") + "Fields"];a = o + "?" + l + "&callback=s_c_il%5B" + S._in + "%5D._set" + (i ? "MarketingCloud" : "Analytics") + "Fields", s.corsUrl = o + "?" + l, s.callback = u;
                  }return s.url = a, S._getRemoteField(i ? k : R, a, e, t, s);
                }
              }return "";
            }, S.getAudienceManagerLocationHint = function (e, t) {
              if (S.isAllowed()) {
                var i = S.getMarketingCloudVisitorID(function (t) {
                  S.getAudienceManagerLocationHint(e, !0);
                });if (i) {
                  var n = S._getField(R);if (!n && H.isTrackingServerPopulated() && (n = S.getAnalyticsVisitorID(function (t) {
                    S.getAudienceManagerLocationHint(e, !0);
                  })), n || !H.isTrackingServerPopulated()) {
                    var r = S._getAudienceManagerURLData(),
                        a = r.url;return S._getRemoteField(x, a, e, t, r);
                  }
                }
              }return "";
            }, S.getLocationHint = S.getAudienceManagerLocationHint, S.getAudienceManagerBlob = function (e, t) {
              if (S.isAllowed()) {
                var i = S.getMarketingCloudVisitorID(function (t) {
                  S.getAudienceManagerBlob(e, !0);
                });if (i) {
                  var n = S._getField(R);if (!n && H.isTrackingServerPopulated() && (n = S.getAnalyticsVisitorID(function (t) {
                    S.getAudienceManagerBlob(e, !0);
                  })), n || !H.isTrackingServerPopulated()) {
                    var r = S._getAudienceManagerURLData(),
                        a = r.url;return S._customerIDsHashChanged && S._setFieldExpire(V, -1), S._getRemoteField(V, a, e, t, r);
                  }
                }
              }return "";
            }, S._supplementalDataIDCurrent = "", S._supplementalDataIDCurrentConsumed = {}, S._supplementalDataIDLast = "", S._supplementalDataIDLastConsumed = {}, S.getSupplementalDataID = function (e, t) {
              S._supplementalDataIDCurrent || t || (S._supplementalDataIDCurrent = S._generateID(1));var i = S._supplementalDataIDCurrent;return S._supplementalDataIDLast && !S._supplementalDataIDLastConsumed[e] ? (i = S._supplementalDataIDLast, S._supplementalDataIDLastConsumed[e] = !0) : i && (S._supplementalDataIDCurrentConsumed[e] && (S._supplementalDataIDLast = S._supplementalDataIDCurrent, S._supplementalDataIDLastConsumed = S._supplementalDataIDCurrentConsumed, S._supplementalDataIDCurrent = i = t ? "" : S._generateID(1), S._supplementalDataIDCurrentConsumed = {}), i && (S._supplementalDataIDCurrentConsumed[e] = !0)), i;
            }, S.getOptOut = function (e, t) {
              if (S.isAllowed()) {
                var i = S._getAudienceManagerURLData("_setMarketingCloudFields"),
                    n = i.url;return S._getRemoteField(L, n, e, t, i);
              }return "";
            }, S.isOptedOut = function (e, t, i) {
              if (S.isAllowed()) {
                t || (t = A.OptOut.GLOBAL);var n = S.getOptOut(function (i) {
                  var n = i === A.OptOut.GLOBAL || i.indexOf(t) >= 0;S._callCallback(e, [n]);
                }, i);return n ? n === A.OptOut.GLOBAL || n.indexOf(t) >= 0 : null;
              }return !1;
            }, S._fields = null, S._fieldsExpired = null, S._hash = function (e) {
              var t,
                  i,
                  n = 0;if (e) for (t = 0; t < e.length; t++) {
                i = e.charCodeAt(t), n = (n << 5) - n + i, n &= n;
              }return n;
            }, S._generateID = g, S._generateLocalMID = function () {
              var e = S._generateID(0);return q.isClientSideMarketingCloudVisitorID = !0, e;
            }, S._callbackList = null, S._callCallback = function (e, t) {
              try {
                "function" == typeof e ? e.apply(v, t) : e[1].apply(e[0], t);
              } catch (e) {}
            }, S._registerCallback = function (e, t) {
              t && (null == S._callbackList && (S._callbackList = {}), void 0 == S._callbackList[e] && (S._callbackList[e] = []), S._callbackList[e].push(t));
            }, S._callAllCallbacks = function (e, t) {
              if (null != S._callbackList) {
                var i = S._callbackList[e];if (i) for (; i.length > 0;) {
                  S._callCallback(i.shift(), t);
                }
              }
            }, S._addQuerystringParam = function (e, t, i, n) {
              var r = encodeURIComponent(t) + "=" + encodeURIComponent(i),
                  a = H.parseHash(e),
                  s = H.hashlessUrl(e),
                  o = s.indexOf("?") === -1;if (o) return s + "?" + r + a;var l = s.split("?"),
                  u = l[0] + "?",
                  d = l[1],
                  c = H.addQueryParamAtLocation(d, r, n);return u + c + a;
            }, S._extractParamFromUri = function (e, t) {
              var i = new RegExp("[\\?&#]" + t + "=([^&#]*)"),
                  n = i.exec(e);if (n && n.length) return decodeURIComponent(n[1]);
            }, S._parseAdobeMcFromUrl = r(_.ADOBE_MC), S._parseAdobeMcSdidFromUrl = r(_.ADOBE_MC_SDID), S._attemptToPopulateSdidFromUrl = function (t) {
              var i = S._parseAdobeMcSdidFromUrl(t),
                  n = 1e9;i && i.TS && (n = H.getTimestampInSeconds() - i.TS), i && i.SDID && i[E] === e && n < S.sdidParamExpiry && (S._supplementalDataIDCurrent = i.SDID, S._supplementalDataIDCurrentConsumed.SDID_URL_PARAM = !0);
            }, S._attemptToPopulateIdsFromUrl = function () {
              var t = S._parseAdobeMcFromUrl();if (t && t.TS) {
                var i = H.getTimestampInSeconds(),
                    n = i - t.TS,
                    r = Math.floor(n / 60);if (r > _.ADOBE_MC_TTL_IN_MIN || t[E] !== e) return;h(t);
              }
            }, S._mergeServerState = function (e) {
              function t(e) {
                H.isObject(e) && S.setCustomerIDs(e);
              }function i(e) {
                return H.isObject(e) ? e : JSON.parse(e);
              }if (e) try {
                if (e = i(e), e[S.marketingCloudOrgID]) {
                  var n = e[S.marketingCloudOrgID];t(n.customerIDs), C(n.sdid);
                }
              } catch (e) {
                throw new Error("`serverState` has an invalid format.");
              }
            }, S._timeout = null, S._loadData = function (e, t, i, n) {
              var r = "d_fieldgroup";t = S._addQuerystringParam(t, r, e, 1), n.url = S._addQuerystringParam(n.url, r, e, 1), n.corsUrl = S._addQuerystringParam(n.corsUrl, r, e, 1), q.fieldGroupObj[e] = !0, n === Object(n) && n.corsUrl && "XMLHttpRequest" === U.corsMetadata.corsType && U.fireCORS(n, i, e);
            }, S._clearTimeout = function (e) {
              null != S._timeout && S._timeout[e] && (clearTimeout(S._timeout[e]), S._timeout[e] = 0);
            }, S._settingsDigest = 0, S._getSettingsDigest = function () {
              if (!S._settingsDigest) {
                var e = S.version;S.audienceManagerServer && (e += "|" + S.audienceManagerServer), S.audienceManagerServerSecure && (e += "|" + S.audienceManagerServerSecure), S._settingsDigest = S._hash(e);
              }return S._settingsDigest;
            }, S._readVisitorDone = !1, S._readVisitor = function () {
              if (!S._readVisitorDone) {
                S._readVisitorDone = !0;var e,
                    t,
                    i,
                    n,
                    r,
                    a,
                    s = S._getSettingsDigest(),
                    o = !1,
                    l = S.cookieRead(S.cookieName),
                    u = new Date();if (null == S._fields && (S._fields = {}), l && "T" !== l) for (l = l.split("|"), l[0].match(/^[\-0-9]+$/) && (parseInt(l[0], 10) !== s && (o = !0), l.shift()), l.length % 2 === 1 && l.pop(), e = 0; e < l.length; e += 2) {
                  t = l[e].split("-"), i = t[0], n = l[e + 1], t.length > 1 ? (r = parseInt(t[1], 10), a = t[1].indexOf("s") > 0) : (r = 0, a = !1), o && (i === T && (n = ""), r > 0 && (r = u.getTime() / 1e3 - 60)), i && n && (S._setField(i, n, 1), r > 0 && (S._fields["expire" + i] = r + (a ? "s" : ""), (u.getTime() >= 1e3 * r || a && !S.cookieRead(S.sessionCookieName)) && (S._fieldsExpired || (S._fieldsExpired = {}), S._fieldsExpired[i] = !0)));
                }!S._getField(R) && H.isTrackingServerPopulated() && (l = S.cookieRead("s_vi"), l && (l = l.split("|"), l.length > 1 && l[0].indexOf("v1") >= 0 && (n = l[1], e = n.indexOf("["), e >= 0 && (n = n.substring(0, e)), n && n.match(_.VALID_VISITOR_ID_REGEX) && S._setField(R, n))));
              }
            }, S._appendVersionTo = function (e) {
              var t = "vVersion|" + S.version,
                  i = e ? S._getCookieVersion(e) : null;return i ? c.areVersionsDifferent(i, S.version) && (e = e.replace(_.VERSION_REGEX, t)) : e += (e ? "|" : "") + t, e;
            }, S._writeVisitor = function () {
              var e,
                  t,
                  i = S._getSettingsDigest();for (e in S._fields) {
                j(e) && S._fields[e] && "expire" !== e.substring(0, 6) && (t = S._fields[e], i += (i ? "|" : "") + e + (S._fields["expire" + e] ? "-" + S._fields["expire" + e] : "") + "|" + t);
              }i = S._appendVersionTo(i), S.cookieWrite(S.cookieName, i, 1);
            }, S._getField = function (e, t) {
              return null == S._fields || !t && S._fieldsExpired && S._fieldsExpired[e] ? null : S._fields[e];
            }, S._setField = function (e, t, i) {
              null == S._fields && (S._fields = {}), S._fields[e] = t, i || S._writeVisitor();
            }, S._getFieldList = function (e, t) {
              var i = S._getField(e, t);return i ? i.split("*") : null;
            }, S._setFieldList = function (e, t, i) {
              S._setField(e, t ? t.join("*") : "", i);
            }, S._getFieldMap = function (e, t) {
              var i = S._getFieldList(e, t);if (i) {
                var n,
                    r = {};for (n = 0; n < i.length; n += 2) {
                  r[i[n]] = i[n + 1];
                }return r;
              }return null;
            }, S._setFieldMap = function (e, t, i) {
              var n,
                  r = null;if (t) {
                r = [];for (n in t) {
                  j(n) && (r.push(n), r.push(t[n]));
                }
              }S._setFieldList(e, r, i);
            }, S._setFieldExpire = function (e, t, i) {
              var n = new Date();n.setTime(n.getTime() + 1e3 * t), null == S._fields && (S._fields = {}), S._fields["expire" + e] = Math.floor(n.getTime() / 1e3) + (i ? "s" : ""), t < 0 ? (S._fieldsExpired || (S._fieldsExpired = {}), S._fieldsExpired[e] = !0) : S._fieldsExpired && (S._fieldsExpired[e] = !1), i && (S.cookieRead(S.sessionCookieName) || S.cookieWrite(S.sessionCookieName, "1"));
            }, S._findVisitorID = function (e) {
              return e && ("object" == typeof e && (e = e.d_mid ? e.d_mid : e.visitorID ? e.visitorID : e.id ? e.id : e.uuid ? e.uuid : "" + e), e && (e = e.toUpperCase(), "NOTARGET" === e && (e = N)), e && (e === N || e.match(_.VALID_VISITOR_ID_REGEX)) || (e = "")), e;
            }, S._setFields = function (e, t) {
              if (S._clearTimeout(e), null != S._loading && (S._loading[e] = !1), q.fieldGroupObj[e] && q.setState(e, !1), e === b) {
                q.isClientSideMarketingCloudVisitorID !== !0 && (q.isClientSideMarketingCloudVisitorID = !1);var i = S._getField(k);if (!i || S.overwriteCrossDomainMCIDAndAID) {
                  if (i = "object" == typeof t && t.mid ? t.mid : S._findVisitorID(t), !i) {
                    if (S._use1stPartyMarketingCloudServer && !S.tried1stPartyMarketingCloudServer) return S.tried1stPartyMarketingCloudServer = !0, void S.getAnalyticsVisitorID(null, !1, !0);i = S._generateLocalMID();
                  }S._setField(k, i);
                }i && i !== N || (i = ""), "object" == typeof t && ((t.d_region || t.dcs_region || t.d_blob || t.blob) && S._setFields(F, t), S._use1stPartyMarketingCloudServer && t.mid && S._setFields(P, { id: t.id })), S._callAllCallbacks(k, [i]);
              }if (e === F && "object" == typeof t) {
                var n = 604800;void 0 != t.id_sync_ttl && t.id_sync_ttl && (n = parseInt(t.id_sync_ttl, 10));var r = B.getRegionAndCheckIfChanged(t, n);S._callAllCallbacks(x, [r]);var a = S._getField(V);(t.d_blob || t.blob) && (a = t.d_blob, a || (a = t.blob), S._setFieldExpire(V, n), S._setField(V, a)), a || (a = ""), S._callAllCallbacks(V, [a]), !t.error_msg && S._newCustomerIDsHash && S._setField(T, S._newCustomerIDsHash);
              }if (e === P) {
                var s = S._getField(R);s && !S.overwriteCrossDomainMCIDAndAID || (s = S._findVisitorID(t), s ? s !== N && S._setFieldExpire(V, -1) : s = N, S._setField(R, s)), s && s !== N || (s = ""), S._callAllCallbacks(R, [s]);
              }if (S.idSyncDisableSyncs || S.disableIdSyncs) B.idCallNotProcesssed = !0;else {
                B.idCallNotProcesssed = !1;var o = {};o.ibs = t.ibs, o.subdomain = t.subdomain, B.processIDCallData(o);
              }if (t === Object(t)) {
                var l, u;S.isAllowed() && (l = S._getField(L)), l || (l = N, t.d_optout && t.d_optout instanceof Array && (l = t.d_optout.join(",")), u = parseInt(t.d_ottl, 10), isNaN(u) && (u = 7200), S._setFieldExpire(L, u, !0), S._setField(L, l)), S._callAllCallbacks(L, [l]);
              }
            }, S._loading = null, S._getRemoteField = function (e, t, i, n, r) {
              var a,
                  s = "",
                  o = H.isFirstPartyAnalyticsVisitorIDCall(e),
                  l = { MCAAMLH: !0, MCAAMB: !0 };if (S.isAllowed()) {
                S._readVisitor(), s = S._getField(e, l[e] === !0);var u = function u() {
                  return (!s || S._fieldsExpired && S._fieldsExpired[e]) && (!S.disableThirdPartyCalls || o);
                };if (u()) {
                  if (e === k || e === L ? a = b : e === x || e === V ? a = F : e === R && (a = P), a) return !t || null != S._loading && S._loading[a] || (null == S._loading && (S._loading = {}), S._loading[a] = !0, S._loadData(a, t, function (t) {
                    if (!S._getField(e)) {
                      t && q.setState(a, !0);var i = "";e === k ? i = S._generateLocalMID() : a === F && (i = { error_msg: "timeout" }), S._setFields(a, i);
                    }
                  }, r)), S._registerCallback(e, i), s ? s : (t || S._setFields(a, { id: N }), "");
                } else s || (e === k ? (S._registerCallback(e, i), s = S._generateLocalMID(), S.setMarketingCloudVisitorID(s)) : e === R ? (S._registerCallback(e, i), s = "", S.setAnalyticsVisitorID(s)) : (s = "", n = !0));
              }return e !== k && e !== R || s !== N || (s = "", n = !0), i && n && S._callCallback(i, [s]), s;
            }, S._setMarketingCloudFields = function (e) {
              S._readVisitor(), S._setFields(b, e);
            }, S._mapCustomerIDs = function (e) {
              S.getAudienceManagerBlob(e, !0);
            }, S._setAnalyticsFields = function (e) {
              S._readVisitor(), S._setFields(P, e);
            }, S._setAudienceManagerFields = function (e) {
              S._readVisitor(), S._setFields(F, e);
            }, S._getAudienceManagerURLData = function (e) {
              var t = S.audienceManagerServer,
                  i = "",
                  n = S._getField(k),
                  r = S._getField(V, !0),
                  a = S._getField(R),
                  s = a && a !== N ? "&d_cid_ic=AVID%01" + encodeURIComponent(a) : "";if (S.loadSSL && S.audienceManagerServerSecure && (t = S.audienceManagerServerSecure), t) {
                var o,
                    l,
                    u = S.getCustomerIDs();if (u) for (o in u) {
                  j(o) && (l = u[o], s += "&d_cid_ic=" + encodeURIComponent(o) + "%01" + encodeURIComponent(l.id ? l.id : "") + (l.authState ? "%01" + l.authState : ""));
                }e || (e = "_setAudienceManagerFields");var d = "http" + (S.loadSSL ? "s" : "") + "://" + t + "/id",
                    c = "d_visid_ver=" + S.version + "&d_rtbd=json&d_ver=2" + (!n && S._use1stPartyMarketingCloudServer ? "&d_verify=1" : "") + "&d_orgid=" + encodeURIComponent(S.marketingCloudOrgID) + "&d_nsid=" + (S.idSyncContainerID || 0) + (n ? "&d_mid=" + encodeURIComponent(n) : "") + (S.idSyncDisable3rdPartySyncing || S.disableThirdPartyCookies ? "&d_coppa=true" : "") + (M === !0 ? "&d_coop_safe=1" : M === !1 ? "&d_coop_unsafe=1" : "") + (r ? "&d_blob=" + encodeURIComponent(r) : "") + s,
                    f = ["s_c_il", S._in, e];return i = d + "?" + c + "&d_cb=s_c_il%5B" + S._in + "%5D." + e, { url: i, corsUrl: d + "?" + c, callback: f };
              }return { url: i };
            }, S.appendVisitorIDsTo = function (e) {
              try {
                var t = [[k, S._getField(k)], [R, S._getField(R)], [E, S.marketingCloudOrgID]];return S._addQuerystringParam(e, _.ADOBE_MC, D(t));
              } catch (t) {
                return e;
              }
            }, S.appendSupplementalDataIDTo = function (e, t) {
              if (t = t || S.getSupplementalDataID(H.generateRandomString(), !0), !t) return e;try {
                var i = D([["SDID", t], [E, S.marketingCloudOrgID]]);return S._addQuerystringParam(e, _.ADOBE_MC_SDID, i);
              } catch (t) {
                return e;
              }
            };var H = { parseHash: function parseHash(e) {
                var t = e.indexOf("#");return t > 0 ? e.substr(t) : "";
              }, hashlessUrl: function hashlessUrl(e) {
                var t = e.indexOf("#");return t > 0 ? e.substr(0, t) : e;
              }, addQueryParamAtLocation: function addQueryParamAtLocation(e, t, i) {
                var n = e.split("&");return i = null != i ? i : n.length, n.splice(i, 0, t), n.join("&");
              }, isFirstPartyAnalyticsVisitorIDCall: function isFirstPartyAnalyticsVisitorIDCall(e, t, i) {
                if (e !== R) return !1;var n;return t || (t = S.trackingServer), i || (i = S.trackingServerSecure), n = S.loadSSL ? i : t, !("string" != typeof n || !n.length) && n.indexOf("2o7.net") < 0 && n.indexOf("omtrdc.net") < 0;
              }, isObject: function isObject(e) {
                return Boolean(e && e === Object(e));
              }, removeCookie: function removeCookie(e) {
                document.cookie = encodeURIComponent(e) + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;" + (S.cookieDomain ? " domain=" + S.cookieDomain + ";" : "");
              }, isTrackingServerPopulated: function isTrackingServerPopulated() {
                return !!S.trackingServer || !!S.trackingServerSecure;
              }, getTimestampInSeconds: function getTimestampInSeconds() {
                return Math.round(new Date().getTime() / 1e3);
              }, parsePipeDelimetedKeyValues: function parsePipeDelimetedKeyValues(e) {
                var t = e.split("|");return t.reduce(function (e, t) {
                  var i = t.split("=");return e[i[0]] = decodeURIComponent(i[1]), e;
                }, {});
              }, generateRandomString: function generateRandomString(e) {
                e = e || 5;for (var t = "", i = "abcdefghijklmnopqrstuvwxyz0123456789"; e--;) {
                  t += i[Math.floor(Math.random() * i.length)];
                }return t;
              }, parseBoolean: function parseBoolean(e) {
                return "true" === e || "false" !== e && null;
              }, replaceMethodsWithFunction: function replaceMethodsWithFunction(e, t) {
                for (var i in e) {
                  e.hasOwnProperty(i) && "function" == typeof e[i] && (e[i] = t);
                }return e;
              }, pluck: function pluck(e, t) {
                return t.reduce(function (t, i) {
                  return e[i] && (t[i] = e[i]), t;
                }, Object.create(null));
              } };S._helpers = H;var B = m(S, A);S._destinationPublishing = B, S.timeoutMetricsLog = [];var G,
                q = { isClientSideMarketingCloudVisitorID: null, MCIDCallTimedOut: null, AnalyticsIDCallTimedOut: null, AAMIDCallTimedOut: null, fieldGroupObj: {}, setState: function setState(e, t) {
                switch (e) {case b:
                    t === !1 ? this.MCIDCallTimedOut !== !0 && (this.MCIDCallTimedOut = !1) : this.MCIDCallTimedOut = t;break;case P:
                    t === !1 ? this.AnalyticsIDCallTimedOut !== !0 && (this.AnalyticsIDCallTimedOut = !1) : this.AnalyticsIDCallTimedOut = t;break;case F:
                    t === !1 ? this.AAMIDCallTimedOut !== !0 && (this.AAMIDCallTimedOut = !1) : this.AAMIDCallTimedOut = t;}
              } };S.isClientSideMarketingCloudVisitorID = function () {
              return q.isClientSideMarketingCloudVisitorID;
            }, S.MCIDCallTimedOut = function () {
              return q.MCIDCallTimedOut;
            }, S.AnalyticsIDCallTimedOut = function () {
              return q.AnalyticsIDCallTimedOut;
            }, S.AAMIDCallTimedOut = function () {
              return q.AAMIDCallTimedOut;
            }, S.idSyncGetOnPageSyncInfo = function () {
              return S._readVisitor(), S._getField(O);
            }, S.idSyncByURL = function (e) {
              var t = I(e || {});if (t.error) return t.error;var i,
                  n,
                  r = e.url,
                  a = encodeURIComponent,
                  s = B;return r = r.replace(/^https:/, "").replace(/^http:/, ""), i = u.encodeAndBuildRequest(["", e.dpid, e.dpuuid || ""], ","), n = ["ibs", a(e.dpid), "img", a(r), t.ttl, "", i], s.addMessage(n.join("|")), s.requestToProcess(), "Successfully queued";
            }, S.idSyncByDataSource = function (e) {
              return e === Object(e) && "string" == typeof e.dpuuid && e.dpuuid.length ? (e.url = "//dpm.demdex.net/ibs:dpid=" + e.dpid + "&dpuuid=" + e.dpuuid, S.idSyncByURL(e)) : "Error: config or config.dpuuid is empty";
            }, S._getCookieVersion = function (e) {
              e = e || S.cookieRead(S.cookieName);var t = _.VERSION_REGEX.exec(e),
                  i = t && t.length > 1 ? t[1] : null;return i;
            }, S._resetAmcvCookie = function (e) {
              var t = S._getCookieVersion();t && !c.isLessThan(t, e) || H.removeCookie(S.cookieName);
            }, S.setAsCoopSafe = function () {
              M = !0;
            }, S.setAsCoopUnsafe = function () {
              M = !1;
            }, S.init = function () {
              function i() {
                if (t && "object" == typeof t) {
                  S.configs = Object.create(null);for (var e in t) {
                    j(e) && (S[e] = t[e], S.configs[e] = t[e]);
                  }S.idSyncContainerID = S.idSyncContainerID || 0, M = "boolean" == typeof S.isCoopSafe ? S.isCoopSafe : H.parseBoolean(S.isCoopSafe), S.resetBeforeVersion && S._resetAmcvCookie(S.resetBeforeVersion), S._attemptToPopulateIdsFromUrl(), S._attemptToPopulateSdidFromUrl(), S._readVisitor();var i = S._getField(w),
                      n = Math.ceil(new Date().getTime() / _.MILLIS_PER_DAY);S.idSyncDisableSyncs || S.disableIdSyncs || !B.canMakeSyncIDCall(i, n) || (S._setFieldExpire(V, -1), S._setField(w, n)), S.getMarketingCloudVisitorID(), S.getAudienceManagerLocationHint(), S.getAudienceManagerBlob(), S._mergeServerState(S.serverState);
                } else S._attemptToPopulateIdsFromUrl(), S._attemptToPopulateSdidFromUrl();
              }function n() {
                if (!S.idSyncDisableSyncs && !S.disableIdSyncs) {
                  B.checkDPIframeSrc();var e = function e() {
                    var e = B;e.readyToAttachIframe() && e.attachIframe();
                  };v.addEventListener("load", function () {
                    A.windowLoaded = !0, e();
                  });try {
                    f.receiveMessage(function (e) {
                      B.receiveMessage(e.data);
                    }, B.iframeHost);
                  } catch (e) {}
                }
              }function r() {
                S.whitelistIframeDomains && _.POST_MESSAGE_ENABLED && (S.whitelistIframeDomains = S.whitelistIframeDomains instanceof Array ? S.whitelistIframeDomains : [S.whitelistIframeDomains], S.whitelistIframeDomains.forEach(function (t) {
                  var i = new a(e, t),
                      n = s(S, i);f.receiveMessage(n, t);
                }));
              }i(), n(), r();
            };
          };h.getInstance = function (e, t) {
            function n() {
              var t = i.s_c_il;if (t) for (var n = 0; n < t.length; n++) {
                var r = t[n];if (r && "Visitor" === r._c && r.marketingCloudOrgID === e) return r;
              }
            }function a() {
              try {
                return i.self !== i.parent;
              } catch (e) {
                return !0;
              }
            }function s() {
              i.s_c_il.splice(--i.s_c_in, 1);
            }function o(e) {
              var t = "TEST_AMCV_COOKIE";return e.cookieWrite(t, "T", 1), "T" === e.cookieRead(t) && (e._helpers.removeCookie(t), !0);
            }if (!e) throw new Error("Visitor requires Adobe Marketing Cloud Org ID.");e.indexOf("@") < 0 && (e += "@AdobeOrg");var l = n();if (l) return l;var d = e,
                c = d.split("").reverse().join(""),
                f = new h(e, null, c);s();var g = u.getIeVersion(),
                p = "number" == typeof g && g < 10;if (p) return f._helpers.replaceMethodsWithFunction(f, function () {});var m = a() && !o(f) && i.parent ? new r(e, t, f, i.parent) : new h(e, t, c);return f = null, m.init(), m;
          }, n(), i.Visitor = h, t.exports = h;
        }).call(this, "undefined" != typeof window && "undefined" != typeof global && window.global === global ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, { "./child/ChildVisitor": 2, "./child/Message": 3, "./child/makeChildMessageListener": 4, "./units/crossDomain": 8, "./units/makeCorsRequest": 9, "./units/makeDestinationPublishing": 10, "./units/version": 11, "./utils/asyncParallelApply": 12, "./utils/constants": 14, "./utils/enums": 15, "./utils/getDomain": 16, "./utils/utils": 18, "@adobe-mcid/visitor-js-shared/lib/ids/generateRandomID": 19 }], 2: [function (e, t, i) {
        (function (i) {
          e("../utils/polyfills");var n = e("./strategies/LocalVisitor"),
              r = e("./strategies/ProxyVisitor"),
              a = e("./strategies/PlaceholderVisitor"),
              s = e("../utils/callbackRegistryFactory"),
              o = e("./Message"),
              l = e("../utils/enums"),
              u = l.MESSAGES;t.exports = function (e, t, l, d) {
            function c(e) {
              Object.assign(I, e);
            }function f(e) {
              Object.assign(I.state, e), I.callbackRegistry.executeAll(I.state);
            }function g(e) {
              if (!A.isInvalid(e)) {
                v = !1;var t = A.parse(e);I.setStateAndPublish(t.state);
              }
            }function p(e) {
              !v && S && (v = !0, A.send(d, e));
            }function m() {
              var e = !0;c(new n(l._generateID)), I.getMarketingCloudVisitorID(), I.callbackRegistry.executeAll(I.state, e), i.removeEventListener("message", _);
            }function _(e) {
              if (!A.isInvalid(e)) {
                var t = A.parse(e);v = !1, i.clearTimeout(this.timeout), i.removeEventListener("message", _), c(new r(I)), i.addEventListener("message", g), I.setStateAndPublish(t.state), I.callbackRegistry.hasCallbacks() && p(u.GETSTATE);
              }
            }function h() {
              var e = 250;S && postMessage ? (i.addEventListener("message", _), p(u.HANDSHAKE), this.timeout = setTimeout(m, e)) : m();
            }function C() {
              i.s_c_in || (i.s_c_il = [], i.s_c_in = 0), I._c = "Visitor", I._il = i.s_c_il, I._in = i.s_c_in, I._il[I._in] = I, i.s_c_in++;
            }function D() {
              function e(e) {
                0 !== e.indexOf("_") && "function" == typeof l[e] && (I[e] = function () {});
              }Object.keys(l).forEach(e), I.getSupplementalDataID = l.getSupplementalDataID;
            }var I = this,
                S = t.whitelistParentDomain;I.state = {}, I.version = l.version, I.marketingCloudOrgID = e;var v = !1,
                A = new o(e, S);I.callbackRegistry = s(), I.init = function () {
              C(), D(), c(new a(I)), h();
            }, I.findField = function (e, t) {
              if (I.state[e]) return t(I.state[e]), I.state[e];
            }, I.messageParent = p, I.setStateAndPublish = f;
          };
        }).call(this, "undefined" != typeof window && "undefined" != typeof global && window.global === global ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, { "../utils/callbackRegistryFactory": 13, "../utils/enums": 15, "../utils/polyfills": 17, "./Message": 3, "./strategies/LocalVisitor": 5, "./strategies/PlaceholderVisitor": 6, "./strategies/ProxyVisitor": 7 }], 3: [function (e, t, i) {
        var n = e("../utils/enums"),
            r = n.MESSAGES,
            a = { 0: "prefix", 1: "orgID", 2: "state" };t.exports = function (e, t) {
          this.parse = function (e) {
            try {
              var t = {},
                  i = e.data.split("|");return i.forEach(function (e, i) {
                if (void 0 !== e) {
                  var n = a[i];t[n] = 2 !== i ? e : JSON.parse(e);
                }
              }), t;
            } catch (e) {}
          }, this.isInvalid = function (i) {
            var n = this.parse(i);if (!n || Object.keys(n).length < 2) return !0;var a = e !== n.orgID,
                s = !t || i.origin !== t,
                o = Object.keys(r).indexOf(n.prefix) === -1;return a || s || o;
          }, this.send = function (i, n, r) {
            var a = n + "|" + e;r && r === Object(r) && (a += "|" + JSON.stringify(r));try {
              i.postMessage(a, t);
            } catch (e) {}
          };
        };
      }, { "../utils/enums": 15 }], 4: [function (e, t, i) {
        var n = e("../utils/enums"),
            r = e("../utils/utils"),
            a = n.MESSAGES,
            s = n.ALL_APIS,
            o = n.ASYNC_API_MAP,
            l = n.FIELDGROUP_TO_FIELD;t.exports = function (e, t) {
          function i() {
            var t = {};return Object.keys(s).forEach(function (i) {
              var n = s[i],
                  a = e[n]();r.isValueEmpty(a) || (t[i] = a);
            }), t;
          }function n() {
            var t = [];return e._loading && Object.keys(e._loading).forEach(function (i) {
              if (e._loading[i]) {
                var n = l[i];t.push(n);
              }
            }), t.length ? t : null;
          }function u(t) {
            return function i(r) {
              var a = n();if (a) {
                var s = o[a[0]];e[s](i, !0);
              } else t();
            };
          }function d(e, n) {
            var r = i();t.send(e, n, r);
          }function c(e) {
            g(e), d(e, a.HANDSHAKE);
          }function f(e) {
            var t = u(function () {
              d(e, a.PARENTSTATE);
            });t();
          }function g(i) {
            function n(n) {
              r.call(e, n), t.send(i, a.PARENTSTATE, { CUSTOMERIDS: e.getCustomerIDs() });
            }var r = e.setCustomerIDs;e.setCustomerIDs = n;
          }return function (e) {
            if (!t.isInvalid(e)) {
              var i = t.parse(e).prefix,
                  n = i === a.HANDSHAKE ? c : f;n(e.source);
            }
          };
        };
      }, { "../utils/enums": 15, "../utils/utils": 18 }], 5: [function (e, t, i) {
        var n = e("../../utils/enums"),
            r = n.STATE_KEYS_MAP;t.exports = function (e) {
          function t() {}function i(t, i) {
            var n = this;return function () {
              var t = e(0, r.MCMID),
                  a = {};return a[r.MCMID] = t, n.setStateAndPublish(a), i(t), t;
            };
          }this.getMarketingCloudVisitorID = function (e) {
            e = e || t;var n = this.findField(r.MCMID, e),
                a = i.call(this, r.MCMID, e);return "undefined" != typeof n ? n : a();
          };
        };
      }, { "../../utils/enums": 15 }], 6: [function (e, t, i) {
        var n = e("../../utils/enums"),
            r = n.ASYNC_API_MAP;t.exports = function () {
          Object.keys(r).forEach(function (e) {
            var t = r[e];this[t] = function (t) {
              this.callbackRegistry.add(e, t);
            };
          }, this);
        };
      }, { "../../utils/enums": 15 }], 7: [function (e, t, i) {
        var n = e("../../utils/enums"),
            r = n.MESSAGES,
            a = n.ASYNC_API_MAP,
            s = n.SYNC_API_MAP;t.exports = function () {
          function e() {}function t(e, t) {
            var i = this;return function () {
              return i.callbackRegistry.add(e, t), i.messageParent(r.GETSTATE), "";
            };
          }function i(i) {
            var n = a[i];this[n] = function (n) {
              n = n || e;var r = this.findField(i, n),
                  a = t.call(this, i, n);return "undefined" != typeof r ? r : a();
            };
          }function n(t) {
            var i = s[t];this[i] = function () {
              var i = this.findField(t, e);return i || {};
            };
          }Object.keys(a).forEach(i, this), Object.keys(s).forEach(n, this);
        };
      }, { "../../utils/enums": 15 }], 8: [function (e, t, i) {
        (function (e) {
          var i = !!e.postMessage;t.exports = { postMessage: function postMessage(e, t, n) {
              var r = 1;t && (i ? n.postMessage(e, t.replace(/([^:]+:\/\/[^\/]+).*/, "$1")) : t && (n.location = t.replace(/#.*$/, "") + "#" + +new Date() + r++ + "&" + e));
            }, receiveMessage: function receiveMessage(t, n) {
              var r;try {
                i && (t && (r = function r(e) {
                  return !("string" == typeof n && e.origin !== n || "[object Function]" === Object.prototype.toString.call(n) && n(e.origin) === !1) && void t(e);
                }), e.addEventListener ? e[t ? "addEventListener" : "removeEventListener"]("message", r) : e[t ? "attachEvent" : "detachEvent"]("onmessage", r));
              } catch (e) {}
            } };
        }).call(this, "undefined" != typeof window && "undefined" != typeof global && window.global === global ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, {}], 9: [function (e, t, i) {
        (function (e) {
          t.exports = function (t, i) {
            return { corsMetadata: function () {
                var t = "none",
                    i = !0;return "undefined" != typeof XMLHttpRequest && XMLHttpRequest === Object(XMLHttpRequest) && ("withCredentials" in new XMLHttpRequest() ? t = "XMLHttpRequest" : "undefined" != typeof XDomainRequest && XDomainRequest === Object(XDomainRequest) && (i = !1), Object.prototype.toString.call(e.HTMLElement).indexOf("Constructor") > 0 && (i = !1)), { corsType: t, corsCookiesEnabled: i };
              }(), getCORSInstance: function getCORSInstance() {
                return "none" === this.corsMetadata.corsType ? null : new e[this.corsMetadata.corsType]();
              }, fireCORS: function fireCORS(i, n, r) {
                function a(t) {
                  var n;try {
                    if (n = JSON.parse(t), n !== Object(n)) return void s.handleCORSError(i, null, "Response is not JSON");
                  } catch (e) {
                    return void s.handleCORSError(i, e, "Error parsing response as JSON");
                  }try {
                    for (var r = i.callback, a = e, o = 0; o < r.length; o++) {
                      a = a[r[o]];
                    }a(n);
                  } catch (e) {
                    s.handleCORSError(i, e, "Error forming callback function");
                  }
                }var s = this;n && (i.loadErrorHandler = n);try {
                  var o = this.getCORSInstance();o.open("get", i.corsUrl + "&ts=" + new Date().getTime(), !0), "XMLHttpRequest" === this.corsMetadata.corsType && (o.withCredentials = !0, o.timeout = t.loadTimeout, o.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), o.onreadystatechange = function () {
                    4 === this.readyState && 200 === this.status && a(this.responseText);
                  }), o.onerror = function (e) {
                    s.handleCORSError(i, e, "onerror");
                  }, o.ontimeout = function (e) {
                    s.handleCORSError(i, e, "ontimeout");
                  }, o.send(), t._log.requests.push(i.corsUrl);
                } catch (e) {
                  this.handleCORSError(i, e, "try-catch");
                }
              }, handleCORSError: function handleCORSError(e, i, n) {
                t.CORSErrors.push({ corsData: e, error: i, description: n }), e.loadErrorHandler && ("ontimeout" === n ? e.loadErrorHandler(!0) : e.loadErrorHandler(!1));
              } };
          };
        }).call(this, "undefined" != typeof window && "undefined" != typeof global && window.global === global ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, {}], 10: [function (e, t, i) {
        (function (i) {
          var n = e("../utils/constants"),
              r = e("./crossDomain"),
              a = e("../utils/utils"),
              s = "MCSYNCSOP",
              o = "MCSYNCS",
              l = "MCAAMLH";t.exports = function (e, t) {
            var u = i.document;return { THROTTLE_START: 3e4, MAX_SYNCS_LENGTH: 649, throttleTimerSet: !1, id: null, onPagePixels: [], iframeHost: null, getIframeHost: function getIframeHost(e) {
                if ("string" == typeof e) {
                  var t = e.split("/");return t[0] + "//" + t[2];
                }
              }, subdomain: null, url: null, getUrl: function getUrl() {
                var t,
                    i = "http://fast.",
                    n = "?d_nsid=" + e.idSyncContainerID + "#" + encodeURIComponent(u.location.href);return this.subdomain || (this.subdomain = "nosubdomainreturned"), e.loadSSL && (i = e.idSyncSSLUseAkamai ? "https://fast." : "https://"), t = i + this.subdomain + ".demdex.net/dest5.html" + n, this.iframeHost = this.getIframeHost(t), this.id = "destination_publishing_iframe_" + this.subdomain + "_" + e.idSyncContainerID, t;
              }, checkDPIframeSrc: function checkDPIframeSrc() {
                var t = "?d_nsid=" + e.idSyncContainerID + "#" + encodeURIComponent(u.location.href);"string" == typeof e.dpIframeSrc && e.dpIframeSrc.length && (this.id = "destination_publishing_iframe_" + (e._subdomain || this.subdomain || new Date().getTime()) + "_" + e.idSyncContainerID, this.iframeHost = this.getIframeHost(e.dpIframeSrc), this.url = e.dpIframeSrc + t);
              }, idCallNotProcesssed: null, doAttachIframe: !1, startedAttachingIframe: !1, iframeHasLoaded: null, iframeIdChanged: null, newIframeCreated: null, originalIframeHasLoadedAlready: null, regionChanged: !1, timesRegionChanged: 0, sendingMessages: !1, messages: [], messagesPosted: [], messagesReceived: [], messageSendingInterval: n.POST_MESSAGE_ENABLED ? null : 100, jsonForComparison: [], jsonDuplicates: [], jsonWaiting: [], jsonProcessed: [], canSetThirdPartyCookies: !0, receivedThirdPartyCookiesNotification: !1, readyToAttachIframe: function readyToAttachIframe() {
                return !e.idSyncDisable3rdPartySyncing && (this.doAttachIframe || e._doAttachIframe) && (this.subdomain && "nosubdomainreturned" !== this.subdomain || e._subdomain) && this.url && !this.startedAttachingIframe;
              }, attachIframe: function attachIframe() {
                function e() {
                  n = u.createElement("iframe"), n.sandbox = "allow-scripts allow-same-origin", n.title = "Adobe ID Syncing iFrame", n.id = i.id, n.name = i.id + "_name", n.style.cssText = "display: none; width: 0; height: 0;", n.src = i.url, i.newIframeCreated = !0, t(), u.body.appendChild(n);
                }function t() {
                  n.addEventListener("load", function () {
                    n.className = "aamIframeLoaded", i.iframeHasLoaded = !0, i.requestToProcess();
                  });
                }this.startedAttachingIframe = !0;var i = this,
                    n = u.getElementById(this.id);n ? "IFRAME" !== n.nodeName ? (this.id += "_2", this.iframeIdChanged = !0, e()) : (this.newIframeCreated = !1, "aamIframeLoaded" !== n.className ? (this.originalIframeHasLoadedAlready = !1, t()) : (this.originalIframeHasLoadedAlready = !0, this.iframeHasLoaded = !0, this.iframe = n, this.requestToProcess())) : e(), this.iframe = n;
              }, requestToProcess: function requestToProcess(t) {
                function i() {
                  a.jsonForComparison.push(t), a.jsonWaiting.push(t), a.processSyncOnPage(t);
                }var r,
                    a = this;if (t === Object(t) && t.ibs) if (r = JSON.stringify(t.ibs || []), this.jsonForComparison.length) {
                  var s,
                      o,
                      l,
                      u = !1;for (s = 0, o = this.jsonForComparison.length; s < o; s++) {
                    if (l = this.jsonForComparison[s], r === JSON.stringify(l.ibs || [])) {
                      u = !0;break;
                    }
                  }u ? this.jsonDuplicates.push(t) : i();
                } else i();if ((this.receivedThirdPartyCookiesNotification || !n.POST_MESSAGE_ENABLED || this.iframeHasLoaded) && this.jsonWaiting.length) {
                  var d = this.jsonWaiting.shift();this.process(d), this.requestToProcess();
                }!e.idSyncDisableSyncs && this.iframeHasLoaded && this.messages.length && !this.sendingMessages && (this.throttleTimerSet || (this.throttleTimerSet = !0, setTimeout(function () {
                  a.messageSendingInterval = n.POST_MESSAGE_ENABLED ? null : 150;
                }, this.THROTTLE_START)), this.sendingMessages = !0, this.sendMessages());
              }, getRegionAndCheckIfChanged: function getRegionAndCheckIfChanged(t, i) {
                var n = e._getField(l),
                    r = t.d_region || t.dcs_region;return n ? r && (e._setFieldExpire(l, i), e._setField(l, r), parseInt(n, 10) !== r && (this.regionChanged = !0, this.timesRegionChanged++, e._setField(s, ""), e._setField(o, ""), n = r)) : (n = r, n && (e._setFieldExpire(l, i), e._setField(l, n))), n || (n = ""), n;
              }, processSyncOnPage: function processSyncOnPage(e) {
                var t, i, n, r;if ((t = e.ibs) && t instanceof Array && (i = t.length)) for (n = 0; n < i; n++) {
                  r = t[n], r.syncOnPage && this.checkFirstPartyCookie(r, "", "syncOnPage");
                }
              }, process: function process(e) {
                var t,
                    i,
                    n,
                    r,
                    s,
                    o = encodeURIComponent,
                    l = "",
                    u = !1;if ((t = e.ibs) && t instanceof Array && (i = t.length)) for (u = !0, n = 0; n < i; n++) {
                  r = t[n], s = [o("ibs"), o(r.id || ""), o(r.tag || ""), a.encodeAndBuildRequest(r.url || [], ","), o(r.ttl || ""), "", l, r.fireURLSync ? "true" : "false"], r.syncOnPage || (this.canSetThirdPartyCookies ? this.addMessage(s.join("|")) : r.fireURLSync && this.checkFirstPartyCookie(r, s.join("|")));
                }u && this.jsonProcessed.push(e);
              }, checkFirstPartyCookie: function checkFirstPartyCookie(t, i, r) {
                var a = "syncOnPage" === r,
                    l = a ? s : o;e._readVisitor();var u,
                    d,
                    c = e._getField(l),
                    f = !1,
                    g = !1,
                    p = Math.ceil(new Date().getTime() / n.MILLIS_PER_DAY);c ? (u = c.split("*"), d = this.pruneSyncData(u, t.id, p), f = d.dataPresent, g = d.dataValid, f && g || this.fireSync(a, t, i, u, l, p)) : (u = [], this.fireSync(a, t, i, u, l, p));
              }, pruneSyncData: function pruneSyncData(e, t, i) {
                var n,
                    r,
                    a,
                    s = !1,
                    o = !1;for (r = 0; r < e.length; r++) {
                  n = e[r], a = parseInt(n.split("-")[1], 10), n.match("^" + t + "-") ? (s = !0, i < a ? o = !0 : (e.splice(r, 1), r--)) : i >= a && (e.splice(r, 1), r--);
                }return { dataPresent: s, dataValid: o };
              }, manageSyncsSize: function manageSyncsSize(e) {
                if (e.join("*").length > this.MAX_SYNCS_LENGTH) for (e.sort(function (e, t) {
                  return parseInt(e.split("-")[1], 10) - parseInt(t.split("-")[1], 10);
                }); e.join("*").length > this.MAX_SYNCS_LENGTH;) {
                  e.shift();
                }
              }, fireSync: function fireSync(t, i, n, r, a, s) {
                var o = this;if (t) {
                  if ("img" === i.tag) {
                    var l,
                        u,
                        d,
                        c,
                        f = i.url,
                        g = e.loadSSL ? "https:" : "http:";for (l = 0, u = f.length; l < u; l++) {
                      d = f[l], c = /^\/\//.test(d);var p = new Image();p.addEventListener("load", function (t, i, n, r) {
                        return function () {
                          o.onPagePixels[t] = null, e._readVisitor();var s,
                              l = e._getField(a),
                              u = [];if (l) {
                            s = l.split("*");var d, c, f;for (d = 0, c = s.length; d < c; d++) {
                              f = s[d], f.match("^" + i.id + "-") || u.push(f);
                            }
                          }o.setSyncTrackingData(u, i, n, r);
                        };
                      }(this.onPagePixels.length, i, a, s)), p.src = (c ? g : "") + d, this.onPagePixels.push(p);
                    }
                  }
                } else this.addMessage(n), this.setSyncTrackingData(r, i, a, s);
              }, addMessage: function addMessage(t) {
                var i = encodeURIComponent,
                    r = i(e._enableErrorReporting ? "---destpub-debug---" : "---destpub---");this.messages.push((n.POST_MESSAGE_ENABLED ? "" : r) + t);
              }, setSyncTrackingData: function setSyncTrackingData(t, i, n, r) {
                t.push(i.id + "-" + (r + Math.ceil(i.ttl / 60 / 24))), this.manageSyncsSize(t), e._setField(n, t.join("*"));
              }, sendMessages: function sendMessages() {
                var e,
                    t = this,
                    i = "",
                    r = encodeURIComponent;this.regionChanged && (i = r("---destpub-clear-dextp---"), this.regionChanged = !1), this.messages.length ? n.POST_MESSAGE_ENABLED ? (e = i + r("---destpub-combined---") + this.messages.join("%01"), this.postMessage(e), this.messages = [], this.sendingMessages = !1) : (e = this.messages.shift(), this.postMessage(i + e), setTimeout(function () {
                  t.sendMessages();
                }, this.messageSendingInterval)) : this.sendingMessages = !1;
              }, postMessage: function postMessage(e) {
                r.postMessage(e, this.url, this.iframe.contentWindow), this.messagesPosted.push(e);
              }, receiveMessage: function receiveMessage(e) {
                var t,
                    i = /^---destpub-to-parent---/;"string" == typeof e && i.test(e) && (t = e.replace(i, "").split("|"), "canSetThirdPartyCookies" === t[0] && (this.canSetThirdPartyCookies = "true" === t[1], this.receivedThirdPartyCookiesNotification = !0, this.requestToProcess()), this.messagesReceived.push(e));
              }, processIDCallData: function processIDCallData(i) {
                (null == this.url || i.subdomain && "nosubdomainreturned" === this.subdomain) && ("string" == typeof e._subdomain && e._subdomain.length ? this.subdomain = e._subdomain : this.subdomain = i.subdomain || "", this.url = this.getUrl()), i.ibs instanceof Array && i.ibs.length && (this.doAttachIframe = !0), this.readyToAttachIframe() && (e.idSyncAttachIframeOnWindowLoad ? (t.windowLoaded || "complete" === u.readyState || "loaded" === u.readyState) && this.attachIframe() : this.attachIframeASAP()), "function" == typeof e.idSyncIDCallResult ? e.idSyncIDCallResult(i) : this.requestToProcess(i), "function" == typeof e.idSyncAfterIDCallResult && e.idSyncAfterIDCallResult(i);
              }, canMakeSyncIDCall: function canMakeSyncIDCall(t, i) {
                return e._forceSyncIDCall || !t || i - t > n.DAYS_BETWEEN_SYNC_ID_CALLS;
              }, attachIframeASAP: function attachIframeASAP() {
                function e() {
                  t.startedAttachingIframe || (u.body ? t.attachIframe() : setTimeout(e, 30));
                }var t = this;e();
              } };
          };
        }).call(this, "undefined" != typeof window && "undefined" != typeof global && window.global === global ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, { "../utils/constants": 14, "../utils/utils": 18, "./crossDomain": 8 }], 11: [function (e, t, i) {
        function n(e) {
          for (var t = /^\d+$/, i = 0, n = e.length; i < n; i++) {
            if (!t.test(e[i])) return !1;
          }return !0;
        }function r(e, t) {
          for (; e.length < t.length;) {
            e.push("0");
          }for (; t.length < e.length;) {
            t.push("0");
          }
        }function a(e, t) {
          for (var i = 0; i < e.length; i++) {
            var n = parseInt(e[i], 10),
                r = parseInt(t[i], 10);if (n > r) return 1;if (r > n) return -1;
          }return 0;
        }function s(e, t) {
          if (e === t) return 0;var i = e.toString().split("."),
              s = t.toString().split(".");return n(i.concat(s)) ? (r(i, s), a(i, s)) : NaN;
        }t.exports = { compare: s, isLessThan: function isLessThan(e, t) {
            return s(e, t) < 0;
          }, areVersionsDifferent: function areVersionsDifferent(e, t) {
            return 0 !== s(e, t);
          }, isGreaterThan: function isGreaterThan(e, t) {
            return s(e, t) > 0;
          }, isEqual: function isEqual(e, t) {
            return 0 === s(e, t);
          } };
      }, {}], 12: [function (e, t, i) {
        t.exports = function (e, t) {
          function i(e) {
            return function (i) {
              n[e] = i, r++;var s = r === a;s && t(n);
            };
          }var n = {},
              r = 0,
              a = Object.keys(e).length;Object.keys(e).forEach(function (t) {
            var n = e[t];if (n.fn) {
              var r = n.args || [];r.unshift(i(t)), n.fn.apply(n.context || null, r);
            }
          });
        };
      }, {}], 13: [function (e, t, i) {
        function n() {
          return { callbacks: {}, add: function add(e, t) {
              this.callbacks[e] = this.callbacks[e] || [];var i = this.callbacks[e].push(t) - 1;return function () {
                this.callbacks[e].splice(i, 1);
              };
            }, execute: function execute(e, t) {
              if (this.callbacks[e]) {
                t = "undefined" == typeof t ? [] : t, t = t instanceof Array ? t : [t];try {
                  for (; this.callbacks[e].length;) {
                    var i = this.callbacks[e].shift();"function" == typeof i ? i.apply(null, t) : i instanceof Array && i[1].apply(i[0], t);
                  }delete this.callbacks[e];
                } catch (e) {}
              }
            }, executeAll: function executeAll(e, t) {
              (t || e && !r.isObjectEmpty(e)) && Object.keys(this.callbacks).forEach(function (t) {
                var i = void 0 !== e[t] ? e[t] : "";this.execute(t, i);
              }, this);
            }, hasCallbacks: function hasCallbacks() {
              return Boolean(Object.keys(this.callbacks).length);
            } };
        }var r = e("./utils");t.exports = n;
      }, { "./utils": 18 }], 14: [function (e, t, i) {
        (function (e) {
          t.exports = { POST_MESSAGE_ENABLED: !!e.postMessage, DAYS_BETWEEN_SYNC_ID_CALLS: 1, MILLIS_PER_DAY: 864e5, ADOBE_MC: "adobe_mc", ADOBE_MC_SDID: "adobe_mc_sdid", VALID_VISITOR_ID_REGEX: /^[0-9a-fA-F\-]+$/, ADOBE_MC_TTL_IN_MIN: 5, VERSION_REGEX: /vVersion\|((\d+\.)?(\d+\.)?(\*|\d+))(?=$|\|)/ };
        }).call(this, "undefined" != typeof window && "undefined" != typeof global && window.global === global ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, {}], 15: [function (e, t, i) {
        i.MESSAGES = { HANDSHAKE: "HANDSHAKE", GETSTATE: "GETSTATE", PARENTSTATE: "PARENTSTATE" }, i.STATE_KEYS_MAP = { MCMID: "MCMID", MCAID: "MCAID", MCAAMB: "MCAAMB", MCAAMLH: "MCAAMLH", MCOPTOUT: "MCOPTOUT", CUSTOMERIDS: "CUSTOMERIDS" }, i.ASYNC_API_MAP = { MCMID: "getMarketingCloudVisitorID", MCAID: "getAnalyticsVisitorID", MCAAMB: "getAudienceManagerBlob", MCAAMLH: "getAudienceManagerLocationHint", MCOPTOUT: "getOptOut" }, i.SYNC_API_MAP = { CUSTOMERIDS: "getCustomerIDs" }, i.ALL_APIS = { MCMID: "getMarketingCloudVisitorID", MCAAMB: "getAudienceManagerBlob", MCAAMLH: "getAudienceManagerLocationHint", MCOPTOUT: "getOptOut", MCAID: "getAnalyticsVisitorID", CUSTOMERIDS: "getCustomerIDs" }, i.FIELDGROUP_TO_FIELD = { MC: "MCMID", A: "MCAID", AAM: "MCAAMB" }, i.FIELDS = { MCMID: "MCMID", MCOPTOUT: "MCOPTOUT", MCAID: "MCAID", MCAAMLH: "MCAAMLH", MCAAMB: "MCAAMB" }, i.AUTH_STATE = { UNKNOWN: 0, AUTHENTICATED: 1, LOGGED_OUT: 2 }, i.OPT_OUT = { GLOBAL: "global" };
      }, {}], 16: [function (e, t, i) {
        (function (e) {
          t.exports = function (t) {
            var i;if (!t && e.location && (t = e.location.hostname), i = t) if (/^[0-9.]+$/.test(i)) i = "";else {
              var n = ",ac,ad,ae,af,ag,ai,al,am,an,ao,aq,ar,as,at,au,aw,ax,az,ba,bb,be,bf,bg,bh,bi,bj,bm,bo,br,bs,bt,bv,bw,by,bz,ca,cc,cd,cf,cg,ch,ci,cl,cm,cn,co,cr,cu,cv,cw,cx,cz,de,dj,dk,dm,do,dz,ec,ee,eg,es,et,eu,fi,fm,fo,fr,ga,gb,gd,ge,gf,gg,gh,gi,gl,gm,gn,gp,gq,gr,gs,gt,gw,gy,hk,hm,hn,hr,ht,hu,id,ie,im,in,io,iq,ir,is,it,je,jo,jp,kg,ki,km,kn,kp,kr,ky,kz,la,lb,lc,li,lk,lr,ls,lt,lu,lv,ly,ma,mc,md,me,mg,mh,mk,ml,mn,mo,mp,mq,mr,ms,mt,mu,mv,mw,mx,my,na,nc,ne,nf,ng,nl,no,nr,nu,nz,om,pa,pe,pf,ph,pk,pl,pm,pn,pr,ps,pt,pw,py,qa,re,ro,rs,ru,rw,sa,sb,sc,sd,se,sg,sh,si,sj,sk,sl,sm,sn,so,sr,st,su,sv,sx,sy,sz,tc,td,tf,tg,th,tj,tk,tl,tm,tn,to,tp,tr,tt,tv,tw,tz,ua,ug,uk,us,uy,uz,va,vc,ve,vg,vi,vn,vu,wf,ws,yt,",
                  r = i.split("."),
                  a = r.length - 1,
                  s = a - 1;if (a > 1 && r[a].length <= 2 && (2 === r[a - 1].length || n.indexOf("," + r[a] + ",") < 0) && s--, s > 0) for (i = ""; a >= s;) {
                i = r[a] + (i ? "." : "") + i, a--;
              }
            }return i;
          };
        }).call(this, "undefined" != typeof window && "undefined" != typeof global && window.global === global ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, {}], 17: [function (e, t, i) {
        Object.assign = Object.assign || function (e) {
          for (var t, i, n = 1; n < arguments.length; ++n) {
            i = arguments[n];for (t in i) {
              Object.prototype.hasOwnProperty.call(i, t) && (e[t] = i[t]);
            }
          }return e;
        };
      }, {}], 18: [function (e, t, i) {
        i.isObjectEmpty = function (e) {
          return e === Object(e) && 0 === Object.keys(e).length;
        }, i.isValueEmpty = function (e) {
          return "" === e || i.isObjectEmpty(e);
        }, i.getIeVersion = function () {
          if (document.documentMode) return document.documentMode;for (var e = 7; e > 4; e--) {
            var t = document.createElement("div");if (t.innerHTML = "<!--[if IE " + e + "]><span></span><![endif]-->", t.getElementsByTagName("span").length) return t = null, e;t = null;
          }return null;
        }, i.encodeAndBuildRequest = function (e, t) {
          return e.map(encodeURIComponent).join(t);
        };
      }, {}], 19: [function (e, t, i) {
        t.exports = function (e) {
          var t,
              i,
              n = "0123456789",
              r = "",
              a = "",
              s = 8,
              o = 10,
              l = 10;if (1 == e) {
            for (n += "ABCDEF", t = 0; 16 > t; t++) {
              i = Math.floor(Math.random() * s), r += n.substring(i, i + 1), i = Math.floor(Math.random() * s), a += n.substring(i, i + 1), s = 16;
            }return r + "-" + a;
          }for (t = 0; 19 > t; t++) {
            i = Math.floor(Math.random() * o), r += n.substring(i, i + 1), 0 === t && 9 == i ? o = 3 : (1 == t || 2 == t) && 10 != o && 2 > i ? o = 10 : 2 < t && (o = 10), i = Math.floor(Math.random() * l), a += n.substring(i, i + 1), 0 === t && 9 == i ? l = 3 : (1 == t || 2 == t) && 10 != l && 2 > i ? l = 10 : 2 < t && (l = 10);
          }return r + a;
        };
      }, {}] }, {}, [1]);
    /* eslint-enable */
    /* global Visitor */

    /**** VISITOR API CONFIG ****/

    var AdobeMarketingCloudId = 'EDA101AC512D2B230A490D4C@AdobeOrg',
        visitor = Visitor.getInstance(AdobeMarketingCloudId, {
      trackingServer: window.visitorServiceTrackingServer || 'w88.go.com', // same as s.trackingServer
      trackingServerSecure: window.visitorServiceTrackingServerSecure || 'sw88.go.com', //same as s.trackingServerSecure

      // To enable CNAME support, add the following configuration variables
      // If you are not using CNAME, DO NOT include these variables
      marketingCloudServer: window.visitorServiceMarketingCloudServer || 'w88.go.com',
      marketingCloudServerSecure: window.visitorServiceMarketingCloudServerSecure || 'sw88.go.com', //same as s.trackingServerSecure
      cookieDomain: window.visitorServiceCookieDomain || undefined,
      cookieLifetime: window.visitorServiceCookieLifetime || undefined,
      idSyncAttachIframeASAP: true
    });

    (function (SWID, loggedInPattern) {
      var clickTaleValues,
          customerIDs = {};

      /***** Clicktale Integration *****/
      function clickTaleGetUID_PID() {
        if (document.cookie.indexOf('WRUID') > -1 && document.cookie.indexOf('WRIgnore=true') == -1) {
          var ca = document.cookie.split(';');
          var PID = 0,
              UID = 0;
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1, c.length);
            }
            if (c.indexOf('CT_Data') > -1) {
              PID = c.substring(c.indexOf('apv_')).split('_')[1];
            }
            if ((document.cookie.match(/WRUID/g) || []).length == 1 && c.indexOf('WRUID') > -1 || c.indexOf('WRUID') > -1 && (document.cookie.match(/WRUID/g) || []).length > 1 && c.indexOf('WRUID=') == -1) {
              UID = c.split('=')[1];
            }
          }
          return UID == 0 || PID == 0 ? null : UID + '.' + PID;
        } else {
          return null;
        }
      }
      if (clickTaleValues = clickTaleGetUID_PID()) {
        customerIDs.ClickTrackingID = clickTaleValues;
      }
      if (SWID && loggedInPattern.test(SWID)) {
        customerIDs.AdobeCampaignID = {
          id: SWID,
          authState: Visitor.AuthState.AUTHENTICATED
        };
        customerIDs.guest_id = {
          id: SWID,
          authState: Visitor.AuthState.AUTHENTICATED
        };
      }
      if (Object.keys(customerIDs)) {
        visitor.setCustomerIDs(customerIDs);
      }
    })(visitor.cookieRead('SWID'), /\{.+\}/);

    [["AdobeMarketingCloudId", AdobeMarketingCloudId], ["visitor", visitor]].forEach(function (arr) {
      window[arr[0]] = arr[1];
    });
  })();
  (function () {
    var mboxCopyright = "Copyright 1996-2015. Adobe Systems Incorporated. All rights reserved.";

    /* WDPRO Additions */
    var tnt_wdpro = {
      aMboxTargets: [],
      // tnt_wdpro.aMboxTargets Hashmap [strMboxName: nodeMBoxElement]
      aMboxTargetsState: [],
      aMboxes: [],
      seenCmpCookie: 'wdpro_seen_cmps',
      // getElement
      // @desciption returns an element via a selector, such as 'jQuery(".home-panel > .bd div:nth-child(4)").get(0)', or by element id
      // @param strTarget Either a query or an element id
      getElement: function getElement(strTarget) {
        if (strTarget) {
          if (strTarget.indexOf('(') > -1) {
            return new Function('return ' + strTarget)();
          } else {
            return document.getElementById(strTarget);
          }
        } else {
          return false;
        }
      },
      showMboxTargetDivs: function showMboxTargetDivs(strMboxName, nodeTarget) {
        if (nodeTarget && typeof nodeTarget === 'object') {
          tnt_wdpro.aMboxTargetsState[strMboxName] = 'visible';
          nodeTarget.style.visibility = 'visible';
        }
      },
      setCookie: function setCookie(name, value, exdays) {
        var exdate = new Date(),
            c_value,
            secure = window.location.protocol === 'https:' ? true : false;
        exdate.setDate(exdate.getDate() + exdays);
        c_value = escape(value) + (exdays == null ? '' : '; expires=' + exdate.toUTCString());
        document.cookie = name + '=' + c_value + '; path=/' + '; secure';
      },
      // get/parse cookies
      getCookie: function getCookie(sName) {
        // reset boolean
        var g_bCookieFound = false;

        // split cookie into name/value pairs
        var aCookies = document.cookie.split(';'),
            aCookiesLength = aCookies.length,
            aCurrCookie = '',
            cookieName = '',
            cookieValue = '',
            i;

        for (i = 0; i < aCookiesLength; i++) {
          // each position now has a string of the form "name=value".
          // split name and value
          aCurrCookie = aCookies[i].split('=');

          // grab cookie name and value. Make sure there is no leading or trailing white space
          cookieName = aCurrCookie[0].replace(/^\s+|\s+$/g, '');

          // check if this is the cookie we are looking for
          if (cookieName === sName) {
            g_bCookieFound = true;

            // watch out for edge case: the cookie might not have an actual value
            if (aCurrCookie[1].length > 1) {
              cookieValue = unescape(aCurrCookie[1].replace(/^\s+|\s+$/g, ''));
            }

            return cookieValue;
          }

          // clean up vars for next iteration
          aCurrCookie = null;
          cookieName = '';
          cookieValue = '';
        }
        if (!g_bCookieFound) {
          return null;
        }
      },
      setCampaign: function setCampaign(campaignId) {
        var seenCmps = tnt_wdpro.getCookie('wdpro_seen_cmps'),
            found = false;

        campaignId = '/' + campaignId.toString() + '/';

        if (seenCmps && seenCmps.indexOf(campaignId) === -1) {
          seenCmps += ',' + campaignId;
        } else if (!seenCmps) {
          seenCmps = campaignId;
        }

        tnt_wdpro.setCookie(this.seenCmpCookie, seenCmps, 14);
      },
      getCampaigns: function getCampaigns() {
        return this.getCookie(this.seenCmpCookie);
      }
    };
    /* End WDPRO Additions */

    var TNT = TNT || {};

    TNT._internal = function () {
      return {
        nestedMboxes: [],

        _settings: {
          companyName: "Test&amp;Target",
          isProduction: true,
          adminUrl: "http://admin5.testandtarget.omniture.com/admin",
          clientCode: "disney",
          serverHost: "disney.tt.omtrdc.net",
          mboxTimeout: 10000,
          mboxLoadedTimeout: 100,
          mboxFactoryDisabledTimeout: 30 * 60,
          bodyPollingTimeout: 16,
          bodyHidingEnabled: false,
          bodyHiddenStyle: "body{opacity:0}",
          sessionExpirationTimeout: 31 * 60,
          experienceManagerDisabledTimeout: 30 * 60,
          experienceManagerTimeout: 5000,
          visitorApiTimeout: 500,
          visitorApiPageDisplayTimeout: 500,
          overrideMboxEdgeServer: true,
          overrideMboxEdgeServerTimeout: 31 * 60,
          tntIdLifetime: 7776000,
          crossDomain: "enabled",
          trafficDuration: 10368000,
          trafficLevelPercentage: 100,
          clientSessionIdSupport: false,
          clientTntIdSupport: false,
          passPageParameters: true,
          usePersistentCookies: true,
          crossDomainEnabled: true,
          crossDomainXOnly: false,
          imsOrgId: "EDA101AC512D2B230A490D4C@AdobeOrg",
          globalMboxName: "target-global-mbox",
          globalMboxLocationDomId: "",
          globalMboxAutoCreate: false,
          experienceManagerPluginUrl: "//cdn.tt.omtrdc.net/cdn/target.js",
          siteCatalystPluginName: "tt",
          mboxVersion: 62,
          optoutEnabled: false,
          secureOnly: false,
          mboxIsSupportedFunction: function mboxIsSupportedFunction() {
            return true;
          },
          parametersFunction: function parametersFunction() {
            return "host=" + window.location;
          },
          cookieDomainFunction: function cookieDomainFunction() {
            return mboxCookiePageDomain();
          }
        },

        _params: {
          _page: "mboxPage",
          _marketingCloudVisitorId: "mboxMCGVID",
          _audienceManagerLocationHint: "mboxMCGLH",
          _audienceManagerBlob: "mboxAAMB",
          _analyticsVisitorId: "mboxMCAVID",
          _supplementalDataId: "mboxMCSDID",
          _count: "mboxCount",
          _host: "mboxHost",
          _mboxFactoryId: "mboxFactoryId",
          _tntId: "mboxPC",
          _screenHeight: "screenHeight",
          _screenWidth: "screenWidth",
          _browserWidth: "browserWidth",
          _browserHeight: "browserHeight",
          _browserTimeOffset: "browserTimeOffset",
          _screenColorDepth: "colorDepth",
          _crossDomain: "mboxXDomain",
          _url: "mboxURL",
          _referrer: "mboxReferrer",
          _mboxVersion: "mboxVersion",
          _mboxName: "mbox",
          _mboxId: "mboxId",
          _domLoaded: "mboxDOMLoaded",
          _time: "mboxTime",
          _siteCatalystPluginVersion: "scPluginVersion"
        },

        _pageParams: {
          _disable: "mboxDisable",
          _sessionId: "mboxSession",
          _environment: "mboxEnv",
          _debug: "mboxDebug"
        },

        _cookies: {
          _disable: "disable",
          _sessionId: "session",
          _tntId: "PC",
          _trafficLevel: "level",
          _check: "check",
          _debug: "debug",
          _experienceManagerDisabled: "em-disabled",
          _mboxEdgeServer: "mboxEdgeServer"
        },

        _constants: {
          _defaultFactoryId: "default",
          _cookieNamePrefix: "mbox",
          _divImportPrefix: "mboxImported-",
          _millisInMinute: 60000,
          _divDefaultClass: "mboxDefault",
          _divMarkerPrefix: "mboxMarker-",
          _mboxNameMaxLength: 250,
          _siteCatalystPluginVersion: 1,
          _mboxEdgeServerPrefix: "mboxedge",
          _mboxClusterHostDomain: "tt.omtrdc.net"
        }
      };
    }();

    TNT._internal._helper = {};

    (function (_module) {
      var _str = {}.toString;

      function _isUndefined(_value) {
        return _value === void 0;
      }

      function _isNull(_value) {
        return _value === null;
      }

      function _isEmpty(_value) {
        if (_isUndefined(_value) || _isNull(_value)) {
          return true;
        }

        return _value.length === 0;
      }

      function _isFunction(_value) {
        return _str.call(_value) === '[object Function]';
      }

      function _isArray(_value) {
        return _str.call(_value) === '[object Array]';
      }

      function _isString(_value) {
        return _str.call(_value) === '[object String]';
      }

      function _isObject(_value) {
        return _str.call(_value) === '[object Object]';
      }

      function _forEach(_arr, _fn) {
        var _len = _arr.length,
            _idx = -1;

        while (++_idx < _len) {
          _fn(_arr[_idx]);
        }
      }

      _module._isUndefined = _isUndefined;
      _module._isNull = _isNull;
      _module._isEmpty = _isEmpty;
      _module._isFunction = _isFunction;
      _module._isArray = _isArray;
      _module._isString = _isString;
      _module._isObject = _isObject;
      _module._forEach = _forEach;
    })(TNT._internal._helper);

    mboxUrlBuilder = function mboxUrlBuilder(_mboxServer, _clientCode) {
      this._mboxServer = _mboxServer;
      this._clientCode = _clientCode;
      this._parameters = [];
      this._urlProcess = function (_url) {
        return _url;
      };
      this._basePath = null;
    };

    mboxUrlBuilder.prototype = {
      constructor: mboxUrlBuilder,

      addNewParameter: function addNewParameter(_name, _value) {
        this._parameters.push({ name: _name, value: _value });

        return this;
      },

      addParameterIfAbsent: function addParameterIfAbsent(_name, _value) {
        if (!_value) {
          return;
        }

        for (var _i = 0; _i < this._parameters.length; _i++) {
          var _parameter = this._parameters[_i];

          if (_parameter.name === _name) {
            return this;
          }
        }

        this.checkInvalidCharacters(_name);

        return this.addNewParameter(_name, _value);
      },

      addParameter: function addParameter(_name, _value) {
        this.checkInvalidCharacters(_name);

        for (var _i = 0; _i < this._parameters.length; _i++) {
          var _parameter = this._parameters[_i];

          if (_parameter.name === _name) {
            _parameter.value = _value;

            return this;
          }
        }

        return this.addNewParameter(_name, _value);
      },

      addParameters: function addParameters(_parameters) {
        if (!_parameters) {
          return this;
        }

        for (var _i = 0; _i < _parameters.length; _i++) {
          var _pair = _parameters[_i];
          var _splitIndex = _pair.indexOf('=');

          if (_splitIndex === -1 || _splitIndex === 0) {
            continue;
          }

          this.addParameter(_pair.substring(0, _splitIndex), _pair.substring(_splitIndex + 1, _pair.length));
        }

        return this;
      },

      setServerType: function setServerType(_type) {
        this._serverType = _type;
      },

      setBasePath: function setBasePath(_basePath) {
        this._basePath = _basePath;
      },

      setUrlProcessAction: function setUrlProcessAction(_action) {
        this._urlProcess = _action;
      },

      buildUrl: function buildUrl() {
        var _secureOnly = TNT._internal._settings.secureOnly,
            _protocol = _secureOnly ? 'https:' : '',
            _server = TNT._internal._getMboxEdgeServer(this._mboxServer),
            _path = this._basePath ? this._basePath : '/m2/' + this._clientCode + '/mbox/' + this._serverType,
            _url = _protocol + '//' + _server + _path,
            _parts = [];

        for (var _i = 0; _i < this._parameters.length; _i++) {
          var _parameter = this._parameters[_i];

          _parts.push(encodeURIComponent(_parameter.name) + '=' + encodeURIComponent(_parameter.value));
        }

        _url += _url.indexOf('?') != -1 ? '&' + _parts.join('&') : '?' + _parts.join('&');

        return this._escapeQuote(this._urlProcess(_url));
      },

      getParameters: function getParameters() {
        return this._parameters;
      },

      setParameters: function setParameters(_parameters) {
        this._parameters = _parameters;
      },

      clone: function clone() {
        var _newUrlBuilder = new mboxUrlBuilder(this._mboxServer, this._clientCode);

        _newUrlBuilder.setServerType(this._serverType);
        _newUrlBuilder.setBasePath(this._basePath);
        _newUrlBuilder.setUrlProcessAction(this._urlProcess);

        for (var _i = 0; _i < this._parameters.length; _i++) {
          _newUrlBuilder.addParameter(this._parameters[_i].name, this._parameters[_i].value);
        }

        return _newUrlBuilder;
      },

      _escapeQuote: function _escapeQuote(_text) {
        return _text.replace(/\"/g, '&quot;').replace(/>/g, '&gt;');
      },

      checkInvalidCharacters: function checkInvalidCharacters(_name) {
        var _invalidCharacters = new RegExp('(\'|")');

        if (_invalidCharacters.exec(_name)) {
          throw "Parameter '" + _name + "' contains invalid characters";
        }
      }
    };

    // This module represents a callback counter or
    // more familiar to Java people a cyclic barrier

    TNT._internal._join = function () {
      var _waiting = [],
          _done = 0,
          _callbacks = [];

      function _partial(_index, _args) {
        _done += 1;
        _waiting[_index] = _args;

        _complete();
      }

      function _complete() {
        var _len = _callbacks.length,
            _idx = -1,
            _cb;

        if (_done !== _waiting.length || !_callbacks.length) {
          return;
        }

        while (++_idx < _len) {
          _cb = _callbacks[_idx];
          _cb.fn.apply(_cb.ctx, _waiting);
        }
      }

      return {
        _add: function _add() {
          var _index = _waiting.length;

          _waiting[_waiting.length] = null;

          return function () {
            _partial(_index, [].slice.call(arguments));
          };
        },

        _then: function _then(cb, context) {
          _callbacks.push({ fn: cb, ctx: context });
          _complete();
        }
      };
    };

    (function (_module, _helper, _params, _settings, _joinFactory) {
      var _MC_ID_COOKIE_REGEXP = new RegExp("\\|MCMID\\|"),
          _VISITOR_PARAM_PREFIX = 'vst.',
          _TRACKING_SERVER_PARAM = _VISITOR_PARAM_PREFIX + 'trk',
          _TRACKING_SERVER_SECURE_PARAM = _VISITOR_PARAM_PREFIX + 'trks';

      function _createParam(_key, _value) {
        return encodeURIComponent(_key) + '=' + encodeURIComponent(_value);
      }

      function _getCustomerIdsParameters(_visitor) {
        var _customerIds,
            _keyFunc = function _keyFunc(_key) {
          return _VISITOR_PARAM_PREFIX + _key;
        };

        if (!_helper._isFunction(_visitor.getCustomerIDs)) {
          return [];
        }

        _customerIds = _visitor.getCustomerIDs();

        if (!_helper._isObject(_customerIds)) {
          return [];
        }

        return _module._extractParamsFromObject(_customerIds, [], _keyFunc);
      }

      function _addTrackingServers(_visitor, _result) {
        var _trackingServer = _visitor.trackingServer,
            _trackingServerSecure = _visitor.trackingServerSecure;

        if (_trackingServer) {
          _result.push(_createParam(_TRACKING_SERVER_PARAM, _trackingServer));
        }

        if (_trackingServerSecure) {
          _result.push(_createParam(_TRACKING_SERVER_SECURE_PARAM, _trackingServerSecure));
        }
      }

      function _addCustomerIdParameters(_visitor, _result) {
        _result.push.apply(_result, _getCustomerIdsParameters(_visitor));
      }

      function _collectVisitorApiParameters(_args) {
        var _result = [];

        _helper._forEach(_args, function (_arr) {
          _result.push(_arr[0]);
        });

        return _result;
      }

      function _hasValue(_item) {
        return !_helper._isEmpty(_item.value);
      }

      function _fireVisitorApiRequest(_join, _visitor, _method, _key) {
        var _notify;

        if (!_helper._isFunction(_visitor[_method])) {
          return;
        }

        _notify = _join._add();

        // We are forcing callback execution for each Visitor API method,
        // this is to ensure an uniform execution, both when data is retrieved from remote server
        // as well as when it is read from cookie
        _visitor[_method](function (_value) {
          _notify({ key: _key, value: _value });
        }, true);
      }

      function _executeForEachVisitorApiMethod(_join, _visitor, _func) {
        _func(_join, _visitor, 'getMarketingCloudVisitorID', _params._marketingCloudVisitorId);
        _func(_join, _visitor, 'getAudienceManagerBlob', _params._audienceManagerBlob);
        _func(_join, _visitor, 'getAnalyticsVisitorID', _params._analyticsVisitorId);
        _func(_join, _visitor, 'getAudienceManagerLocationHint', _params._audienceManagerLocationHint);
      }

      function _fireVisitorApiRequests(_join, _visitor, _timerContext, _optout, _callback) {
        if (_optout) {
          window.clearTimeout(_timerContext.id);

          _callback({ optout: _optout, params: [] });

          _showBodyIfRequired();

          return;
        }

        _executeForEachVisitorApiMethod(_join, _visitor, _fireVisitorApiRequest);

        _join._then(function () {
          if (_timerContext.done) {
            return;
          }

          var _params = _collectVisitorApiParameters([].slice.call(arguments)),
              _result = [];

          window.clearTimeout(_timerContext.id);

          _helper._forEach(_params, function (_item) {
            if (_hasValue(_item)) {
              _result.push(_createParam(_item.key, _item.value));
            }
          });

          _addCustomerIdParameters(_visitor, _result);
          _addTrackingServers(_visitor, _result);

          _callback({ optout: _optout, params: _result });

          _showBodyIfRequired();
        });
      }

      function _getVisitorApiClientIfExists(_imsOrgId) {
        var _visitor;

        if (_helper._isEmpty(_imsOrgId) || _helper._isUndefined(window.Visitor) || !_helper._isFunction(window.Visitor.getInstance)) {
          return null;
        }

        _visitor = window.Visitor.getInstance(_imsOrgId);

        if (_helper._isUndefined(_visitor) || _helper._isNull(_visitor) || !_visitor.isAllowed()) {
          return null;
        }

        return _visitor;
      }

      // Exported functions

      function _isVisitorApiAvailable() {
        return !_helper._isNull(_getVisitorApiClientIfExists(_settings.imsOrgId));
      }

      function _isMarketingCloudDataAvailable() {
        var _visitor = _getVisitorApiClientIfExists(_settings.imsOrgId);

        if (_helper._isNull(_visitor)) {
          return false;
        }

        if (_helper._isUndefined(_visitor.cookieName)) {
          return false;
        }

        if (!_helper._isFunction(_visitor.cookieRead)) {
          return false;
        }

        var _visitorCookie = _visitor.cookieRead(_visitor.cookieName);

        if (_helper._isEmpty(_visitorCookie)) {
          return false;
        }

        return _MC_ID_COOKIE_REGEXP.test(_visitorCookie);
      }

      function _shouldUseOptout(_visitor, _optoutEnabled) {
        return _optoutEnabled && _helper._isFunction(_visitor.isOptedOut) && !_helper._isUndefined(window.Visitor.OptOut);
      }

      function _getMarketingCloudDataAsync(_optoutEnabled, _callback) {
        var _imsOrgId = _settings.imsOrgId,
            _visitorApiTimeout = _settings.visitorApiTimeout,
            _join = _joinFactory(),
            _timerContext = { id: NaN, done: false },
            _visitor;

        _visitor = _getVisitorApiClientIfExists(_imsOrgId);

        if (_helper._isNull(_visitor)) {
          _callback(null);

          return;
        }

        _hideBodyIfRequired();

        _timerContext.id = window.setTimeout(function () {
          _timerContext.done = true;

          _callback(null);

          _showBodyIfRequired();
        }, _visitorApiTimeout);

        if (_shouldUseOptout(_visitor, _optoutEnabled)) {
          _visitor.isOptedOut(function (_optout) {
            _fireVisitorApiRequests(_join, _visitor, _timerContext, _optout, _callback);
          }, window.Visitor.OptOut.GLOBAL, true);
        } else {
          _fireVisitorApiRequests(_join, _visitor, _timerContext, false, _callback);
        }
      }

      function _addParam(_visitor, _method, _key, _accumulator) {
        if (_visitor[_method]) {
          var _value = _visitor[_method]();

          if (_value) {
            _accumulator.push(_createParam(_key, _value));
          }
        }
      }

      function _getMarketingCloudData() {
        var _visitor = _getVisitorApiClientIfExists(_settings.imsOrgId),
            _result = [];

        _addParam(_visitor, 'getMarketingCloudVisitorID', _params._marketingCloudVisitorId, _result);
        _addParam(_visitor, 'getAudienceManagerBlob', _params._audienceManagerBlob, _result);
        _addParam(_visitor, 'getAnalyticsVisitorID', _params._analyticsVisitorId, _result);
        _addParam(_visitor, 'getAudienceManagerLocationHint', _params._audienceManagerLocationHint, _result);

        _addCustomerIdParameters(_visitor, _result);
        _addTrackingServers(_visitor, _result);

        return _result;
      }

      function _generateSupplementalDataId(_mboxName) {
        var _imsOrgId = _settings.imsOrgId,
            _clientCode = _settings.clientCode,
            _visitor = _getVisitorApiClientIfExists(_imsOrgId);

        if (_helper._isNull(_visitor) || !_helper._isFunction(_visitor.getSupplementalDataID)) {
          return '';
        }

        return _visitor.getSupplementalDataID('mbox:' + _clientCode + ':' + _mboxName);
      }

      function _hideBodyIfRequired() {
        if (!_settings.bodyHidingEnabled) {
          return;
        }

        if (!_settings.globalMboxAutoCreate) {
          return;
        }

        var _head = document.getElementsByTagName('head')[0];
        var _style = document.createElement('style');
        _style.type = 'text/css';
        _style.id = 'at-id-body-style';

        if (_style.styleSheet) {
          _style.styleSheet.cssText = css;
        } else {
          _style.appendChild(document.createTextNode(_settings.bodyHiddenStyle));
        }

        if (_head) {
          _head.appendChild(_style);
        }
      }

      function _showBodyIfRequired() {
        if (!_settings.bodyHidingEnabled) {
          return;
        }

        if (!_settings.globalMboxAutoCreate) {
          return;
        }

        window.setTimeout(function () {
          var _head = document.getElementsByTagName('head')[0];
          var _style = document.getElementById('at-id-body-style');

          if (_head && _style) {
            _head.removeChild(_style);
          }
        }, _settings.visitorApiPageDisplayTimeout);
      }

      _module._isVisitorApiAvailable = _isVisitorApiAvailable;
      _module._isMarketingCloudDataAvailable = _isMarketingCloudDataAvailable;
      _module._getMarketingCloudDataAsync = _getMarketingCloudDataAsync;
      _module._getMarketingCloudData = _getMarketingCloudData;
      _module._generateSupplementalDataId = _generateSupplementalDataId;
    })(TNT._internal, TNT._internal._helper, TNT._internal._params, TNT._internal._settings, TNT._internal._join);

    mboxStandardFetcher = function mboxStandardFetcher() {};

    mboxStandardFetcher.prototype = {
      constructor: mboxStandardFetcher,

      getType: function getType() {
        return 'standard';
      },

      fetch: function fetch(_urlBuilder) {
        _urlBuilder.setServerType(this.getType());

        document.write('<' + 'scr' + 'ipt src="' + _urlBuilder.buildUrl() + '"><' + '\/scr' + 'ipt>');
      },

      cancel: function cancel() {}
    };

    mboxAjaxFetcher = function mboxAjaxFetcher() {};

    mboxAjaxFetcher.prototype = {
      constructor: mboxAjaxFetcher,

      getType: function getType() {
        return 'ajax';
      },

      fetch: function fetch(_urlBuilder) {
        _urlBuilder.setServerType(this.getType());

        var _head = document.getElementsByTagName('head')[0],
            _include = document.createElement('script');

        _include.src = _urlBuilder.buildUrl();

        _head.appendChild(_include);
      },

      cancel: function cancel() {}
    };

    (function (_module) {
      function _globalMboxFetcher() {}

      _globalMboxFetcher.prototype = {
        constructor: _globalMboxFetcher,

        getType: function getType() {
          return 'ajax';
        },

        fetch: function fetch(_urlBuilder) {
          _urlBuilder.setServerType(this.getType());

          document.write('<' + 'scr' + 'ipt src="' + _urlBuilder.buildUrl() + '"><' + '\/scr' + 'ipt>');
        },

        cancel: function cancel() {}
      };

      _module._globalMboxFetcher = _globalMboxFetcher;
    })(TNT._internal);

    mboxMap = function mboxMap() {
      this._backingMap = {};
      this._keys = [];
    };

    mboxMap.prototype = {
      constructor: mboxMap,

      put: function put(_key, _value) {
        if (!this._backingMap[_key]) {
          this._keys[this._keys.length] = _key;
        }

        this._backingMap[_key] = _value;
      },

      get: function get(_key) {
        return this._backingMap[_key];
      },

      remove: function remove(_key) {
        var _updatedKeys = [];
        this._backingMap[_key] = undefined;

        for (var i = 0; i < this._keys.length; i++) {
          if (this._keys[i] !== _key) {
            _updatedKeys.push(this._keys[i]);
          }
        }

        this._keys = _updatedKeys;
      },

      each: function each(_action) {
        for (var _i = 0; _i < this._keys.length; _i++) {
          var _key = this._keys[_i];
          var _value = this._backingMap[_key];

          if (_value) {
            var _result = _action(_key, _value);

            if (_result === false) {
              break;
            }
          }
        }
      },

      isEmpty: function isEmpty() {
        return this._keys.length === 0;
      }
    };

    mboxList = function mboxList() {
      this._mboxes = [];
    };

    mboxList.prototype = {
      constructor: mboxList,

      add: function add(_mbox) {
        if (!_mbox) {
          return;
        }

        this._mboxes.push(_mbox);
      },

      get: function get(_mboxName) {
        var _result = new mboxList();

        for (var _i = 0; _i < this._mboxes.length; _i++) {
          var _mbox = this._mboxes[_i];

          if (_mbox.getName() === _mboxName) {
            _result.add(_mbox);
          }
        }

        return _result;
      },

      getById: function getById(_index) {
        return this._mboxes[_index];
      },

      length: function length() {
        return this._mboxes.length;
      },

      each: function each(_action) {
        var _helper = TNT._internal._helper;

        if (!_helper._isFunction(_action)) {
          throw 'Action must be a function, was: ' + typeof _action;
        }

        for (var _i = 0; _i < this._mboxes.length; _i++) {
          _action(this._mboxes[_i]);
        }
      }
    };

    mboxSignaler = function mboxSignaler(_factory) {
      this._factory = _factory;
    };

    mboxSignaler.prototype = {
      constructor: mboxSignaler,

      signal: function signal(_signalType, _mboxName /*,...*/) {
        if (!this._factory.isEnabled()) {
          return;
        }

        var _body = mboxSignaler._getDocumentBody(),
            _divNode = this._createDivNode(this._factory._getMboxMarkerDivId(_mboxName));

        _body.appendChild(_divNode);

        var _args = [].slice.call(arguments, 1),
            _mbox = this._factory.create(_mboxName, _args, _divNode),
            _urlBuilder = _mbox.getUrlBuilder();

        _urlBuilder.addParameter(TNT._internal._params._page, mboxGenerateId());
        _mbox.setFetcher(new mboxAjaxFetcher());
        _mbox.load();
      },

      _createDivNode: function _createDivNode(_id) {
        var _result = document.createElement('div');

        _result.id = _id;
        _result.style.visibility = 'hidden';
        _result.style.display = 'none';

        return _result;
      }
    };

    mboxSignaler._getDocumentBody = function () {
      return document.body;
    };

    //
    // Note this constructor also writes a node to the DOM, do not create
    // after the page is loaded
    //
    mboxLocatorDefault = function mboxLocatorDefault(_divId) {
      this._divId = _divId;

      document.write('<div id="' + this._divId + '" style="visibility:hidden;display:none">&nbsp;<\/div>');
    };

    mboxLocatorDefault.prototype = {
      constructor: mboxLocatorDefault,

      locate: function locate() {
        var _ELEMENT_NODE = 1,
            _node = document.getElementById(this._divId);

        while (_node) {
          if (_node.nodeType === _ELEMENT_NODE && _node.className && _node.className.indexOf('mboxDefault') !== -1) {
            return _node;
          }

          _node = _node.previousSibling;
        }

        return null;
      },

      force: function force() {
        // There was no default div, add an empty one
        var _marker = document.getElementById(this._divId),
            _div = document.createElement('div');

        _div.className = 'mboxDefault';

        if (_marker) {
          _marker.parentNode.insertBefore(_div, _marker);
        }

        return _div;
      }
    };

    mboxLocatorNode = function mboxLocatorNode(_node) {
      this._node = _node;
    };

    mboxLocatorNode.prototype = {
      constructor: mboxLocatorNode,

      locate: function locate() {
        return typeof this._node === 'string' ? document.getElementById(this._node) : this._node;
      },

      force: function force() {
        return null;
      }
    };

    mboxOfferContent = function mboxOfferContent() {
      this._onLoad = function () {};
    };

    mboxOfferContent.prototype = {
      constructor: mboxOfferContent,

      show: function show(_mbox) {
        var _result = _mbox.showContent(document.getElementById(_mbox.getImportName()));

        if (_result === 1) {
          this._onLoad();
        }

        return _result;
      },

      setOnLoad: function setOnLoad(_onLoad) {
        this._onLoad = _onLoad;
      }
    };

    mboxOfferAjax = function mboxOfferAjax(_content) {
      this._content = _content;
      this._onLoad = function () {};
    };

    mboxOfferAjax.prototype = {
      constructor: mboxOfferAjax,

      setOnLoad: function setOnLoad(_onLoad) {
        this._onLoad = _onLoad;
      },

      show: function show(_mbox) {
        var _contentDiv = document.createElement('div'),
            _result;

        _contentDiv.id = _mbox.getImportName();
        _contentDiv.innerHTML = this._content;

        _result = _mbox.showContent(_contentDiv);

        if (_result === 1) {
          this._onLoad();
        }

        return _result;
      }
    };

    mboxOfferDefault = function mboxOfferDefault() {
      this._onLoad = function () {};
    };

    mboxOfferDefault.prototype = {
      constructor: mboxOfferDefault,

      show: function show(_mbox) {
        var _result = _mbox.hide();

        if (_result === 1) {
          this._onLoad();
        }

        return _result;
      },

      setOnLoad: function setOnLoad(_onLoad) {
        this._onLoad = _onLoad;
      }
    };

    mboxCookieManager = function mboxCookieManager(_name, _domain) {
      this._name = _name;
      this._checkCookie = TNT._internal._cookies._check;
      this._crossDomainXOnly = TNT._internal._settings.crossDomainXOnly;
      this._disableCookie = TNT._internal._cookies._disable;
      this._usePersistentCookies = TNT._internal._settings.usePersistentCookies;
      this._cookiesMap = new mboxMap();

      // single word domains are not accepted in a cookie domain clause
      this._domain = _domain === '' || _domain.indexOf('.') === -1 ? '' : '; domain=' + _domain;

      this.loadCookies();
    };

    mboxCookieManager.prototype = {
      constructor: mboxCookieManager,

      isEnabled: function isEnabled() {
        this.setCookie(this._checkCookie, 'true', 60);
        this.loadCookies();

        return this.getCookie(this._checkCookie) == 'true';
      },

      setCookie: function setCookie(_name, _value, _duration) {
        if (typeof _name == 'undefined' || typeof _value == 'undefined' || typeof _duration == 'undefined') {
          return;
        }

        var _expireOn = Math.ceil(_duration + new Date().getTime() / 1000),
            _cookie = mboxCookieManager._createCookie(_name, encodeURIComponent(_value), _expireOn);

        this._cookiesMap.put(_name, _cookie);
        this.saveCookies();
      },

      getCookie: function getCookie(_name) {
        var _cookie = this._cookiesMap.get(_name);

        return _cookie ? decodeURIComponent(_cookie.value) : null;
      },

      deleteCookie: function deleteCookie(_name) {
        this._cookiesMap.remove(_name);
        this.saveCookies();
      },

      getCookieNames: function getCookieNames(_namePrefix) {
        var _cookieNames = [];

        this._cookiesMap.each(function (_name, _cookie) {
          if (_name.indexOf(_namePrefix) === 0) {
            _cookieNames[_cookieNames.length] = _name;
          }
        });

        return _cookieNames;
      },

      saveCookies: function saveCookies() {
        var _self = this,
            _cookieValues = [],
            _maxExpireOn = 0;

        this._cookiesMap.each(function (_name, _cookie) {
          if (!_self._crossDomainXOnly || _name === _self._disableCookie) {
            _cookieValues[_cookieValues.length] = mboxCookieManager._serializeCookie(_cookie);

            if (_maxExpireOn < _cookie.expireOn) {
              _maxExpireOn = _cookie.expireOn;
            }
          }
        });

        var _expiration = new Date(_maxExpireOn * 1000);
        var _parts = [];

        _parts.push(this._name, '=', _cookieValues.join('|'));

        if (_self._usePersistentCookies) {
          _parts.push('; expires=', _expiration.toGMTString());
        }

        _parts.push('; path=/', this._domain);

        document.cookie = _parts.join("");
      },

      loadCookies: function loadCookies() {
        var _masterCookie = mboxCookieManager._getMasterCookie(this._name),
            _internalCookies = mboxCookieManager._getInternalCookies(_masterCookie),
            _nowInSeconds = Math.ceil(new Date().getTime() / 1000);

        this._cookiesMap = new mboxMap();

        for (var _i = 0; _i < _internalCookies.length; _i++) {
          var _cookie = mboxCookieManager._deserializeCookie(_internalCookies[_i]);

          if (_nowInSeconds > _cookie.expireOn) {
            continue;
          }

          this._cookiesMap.put(_cookie.name, _cookie);
        }
      }
    };

    mboxCookieManager._serializeCookie = function (_cookie) {
      return _cookie.name + '#' + _cookie.value + '#' + _cookie.expireOn;
    };

    mboxCookieManager._deserializeCookie = function (_str) {
      var _parts = _str.split('#');

      return mboxCookieManager._createCookie(_parts[0], _parts[1], _parts[2]);
    };

    mboxCookieManager._createCookie = function (_name, _value, _expireOn) {
      return { name: _name, value: _value, expireOn: _expireOn };
    };

    mboxCookieManager._getMasterCookie = function (_name) {
      var result = new RegExp('(^|; )' + encodeURIComponent(_name) + '=([^;]*)').exec(document.cookie);

      return result ? result[2] : null;
    };

    mboxCookieManager._getInternalCookies = function (_str) {
      if (!_str) {
        return [];
      }

      return _str.split('|');
    };

    mboxSession = function mboxSession(_randomId, _pageParamName, _cookieName, _expireTime, _cookieManager) {
      var _forcedSessionId = window.mboxForceSessionId;
      this._cookieName = _cookieName;
      this._expireTime = _expireTime;
      this._cookieManager = _cookieManager;
      this._id = typeof _forcedSessionId !== 'undefined' ? _forcedSessionId : mboxGetPageParameter(_pageParamName, true);
      this._id = this._id || _cookieManager.getCookie(_cookieName) || _randomId;

      this._cookieManager.setCookie(_cookieName, this._id, _expireTime);
    };

    mboxSession.prototype = {
      constructor: mboxSession,

      getId: function getId() {
        return this._id;
      },

      forceId: function forceId(_forcedId) {
        this._id = _forcedId;

        this._cookieManager.setCookie(this._cookieName, this._id, this._expireTime);
      }
    };

    mboxPC = function mboxPC(_cookieName, _expireTime, _cookieManager) {
      var _forcedPCId = window.mboxForcePCId;
      this._cookieName = _cookieName;
      this._expireTime = _expireTime;
      this._cookieManager = _cookieManager;
      this._id = typeof _forcedPCId != 'undefined' ? _forcedPCId : _cookieManager.getCookie(_cookieName);

      if (this._id) {
        _cookieManager.setCookie(_cookieName, this._id, _expireTime);
      }
    };

    mboxPC.prototype = {
      constructor: mboxPC,

      getId: function getId() {
        return this._id;
      },

      forceId: function forceId(_forcedId) {
        if (this._id === _forcedId) {
          return false;
        }

        this._id = _forcedId;
        this._cookieManager.setCookie(this._cookieName, this._id, this._expireTime);

        return true;
      }
    };

    (function (_module, _helper, _cookies, _settings, _constants) {
      var _mboxEdgeExtractorRegex = new RegExp(".*\\.(\\d+)_\\d+");

      function _getMboxEdgeServer(_pcIdValue) {
        var _match = _mboxEdgeExtractorRegex.exec(_pcIdValue);

        if (_match && _match.length === 2) {
          return _constants._mboxEdgeServerPrefix + _match[1] + '.' + _constants._mboxClusterHostDomain;
        }

        return '';
      }

      function _saveMboxEdgeServerToCookieIfExists(_cookieManager, _pcId) {
        var _server = _getMboxEdgeServer(_pcId);

        if (!_helper._isEmpty(_server)) {
          _cookieManager.setCookie(_cookies._mboxEdgeServer, _server, _settings.overrideMboxEdgeServerTimeout);
        }
      }

      function _pcDecorator(_pc, _cookieManager) {
        this._pc = _pc;
        this._cookieManager = _cookieManager;

        _saveMboxEdgeServerToCookieIfExists(_cookieManager, _pc.getId());
      }

      _pcDecorator.prototype = {
        constructor: _pcDecorator,

        getId: function getId() {
          return this._pc.getId();
        },

        forceId: function forceId(_forcedId) {
          if (!this._pc.forceId(_forcedId)) {
            return false;
          }

          _saveMboxEdgeServerToCookieIfExists(this._cookieManager, _forcedId);

          return true;
        }
      };

      _module._pcDecorator = _pcDecorator;
    })(TNT._internal, TNT._internal._helper, TNT._internal._cookies, TNT._internal._settings, TNT._internal._constants);
    mboxGetPageParameter = function mboxGetPageParameter(_name, _ignoreCase) {
      _ignoreCase = _ignoreCase || false;

      var _parameterRegExp;

      if (_ignoreCase) {
        _parameterRegExp = new RegExp("\\?[^#]*" + _name + "=([^\&;#]*)", "i");
      } else {
        _parameterRegExp = new RegExp("\\?[^#]*" + _name + "=([^\&;#]*)");
      }

      var _result = null;
      var _parameterMatch = _parameterRegExp.exec(document.location);

      if (_parameterMatch && _parameterMatch.length >= 2) {
        _result = _parameterMatch[1];
      }

      return _result;
    };

    mboxCookiePageDomain = function mboxCookiePageDomain() {
      var _domain = /([^:]*)(:[0-9]{0,5})?/.exec(document.location.host)[1];
      var _ipRegExp = /[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}/;

      if (!_ipRegExp.exec(_domain)) {
        var _baseDomain = /([^\.]+\.[^\.]{3}|[^\.]+\.[^\.]+\.[^\.]{2})$/.exec(_domain);

        if (_baseDomain) {
          _domain = _baseDomain[0];

          if (_domain.indexOf("www.") === 0) {
            _domain = _domain.substr(4);
          }
        }
      }

      return _domain ? _domain : "";
    };

    mboxShiftArray = function mboxShiftArray(_iterable) {
      var _result = [];

      for (var _i = 1; _i < _iterable.length; _i++) {
        _result[_result.length] = _iterable[_i];
      }

      return _result;
    };

    mboxGenerateId = function mboxGenerateId() {
      // http://www.ietf.org/rfc/rfc4122.txt
      var s = [],
          hex = '0123456789abcdef';

      for (var i = 0; i < 36; i++) {
        s[i] = hex.substr(Math.floor(Math.random() * 0x10), 1);
      }
      // bits 12-15 of the time_hi_and_version field to 0010
      s[14] = '4';
      // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[19] = hex.substr(s[19] & 0x3 | 0x8, 1);
      s[8] = s[13] = s[18] = s[23] = '-';

      return s.join('').replace(/-/g, '');
    };

    mboxScreenHeight = function mboxScreenHeight() {
      return screen.height;
    };

    mboxScreenWidth = function mboxScreenWidth() {
      return screen.width;
    };

    mboxBrowserWidth = function mboxBrowserWidth() {
      return window.innerWidth ? window.innerWidth : document.documentElement ? document.documentElement.clientWidth : document.body.clientWidth;
    };

    mboxBrowserHeight = function mboxBrowserHeight() {
      return window.innerHeight ? window.innerHeight : document.documentElement ? document.documentElement.clientHeight : document.body.clientHeight;
    };

    mboxBrowserTimeOffset = function mboxBrowserTimeOffset() {
      return -new Date().getTimezoneOffset();
    };

    mboxScreenColorDepth = function mboxScreenColorDepth() {
      return screen.pixelDepth;
    };

    /**
     * Class that is the base of all mbox types.
     * @PrivateClass
     *
     * @param _name - name of mbox
     * @param _id - index of this mbox in the list of mboxes of the same name
     * @param _urlBuilder - used to build url of the request
     * @param _mboxLocator object must support
     *   DOMNode locate() which should return null until the DOMNode is found.
     *   DOMNode force() which as a last resort should attempt to create
     *                   a DOMNOde and return it or null
     * @param _importName id of the node containing offer content
     * @param _factory factory that tries to create this mbox
     */
    mbox = function mbox(_name, _id, _urlBuilder, _mboxLocator, _importName, _factory) {
      this._timeout = null;
      this._activated = 0;
      this._locator = _mboxLocator;
      this._importName = _importName;
      this._contentFetcher = null;

      this._offer = new mboxOfferContent();
      this._div = null;
      this._urlBuilder = _urlBuilder;

      // Information to support debugging
      this.message = '';
      this._times = {};
      this._activateCount = 0;
      this._maxActivateCount = 5;

      this._id = _id;
      this._name = _name;

      this._validateName();

      _urlBuilder.addParameter(TNT._internal._params._mboxName, _name);
      _urlBuilder.addParameter(TNT._internal._params._mboxId, _id);

      this._onError = function () {};
      this._onLoad = function () {};

      this._defaultDiv = null;
      // enabled for IE10+ only during page load
      this._waitForNestedMboxes = document.documentMode >= 10 && !_factory.isDomLoaded();

      if (this._waitForNestedMboxes) {
        this._nestedMboxes = TNT._internal.nestedMboxes;
        this._nestedMboxes.push(this._name);
      }
    };

    mbox.prototype.getId = function () {
      return this._id;
    };

    mbox.prototype._validateName = function () {
      var maxLength = TNT._internal._constants._mboxNameMaxLength;

      if (this._name.length > maxLength) {
        throw "Mbox Name " + this._name + " exceeds max length of " + maxLength + " characters.";
      } else if (this._name.match(/^\s+|\s+$/g)) {
        throw "Mbox Name " + this._name + " has leading/trailing whitespace(s).";
      }
    };

    mbox.prototype.getName = function () {
      return this._name;
    };

    /**
     * @return Array an array of parameters
     */
    mbox.prototype.getParameters = function () {
      var _parameters = this._urlBuilder.getParameters();
      var _result = [];

      for (var _i = 0; _i < _parameters.length; _i++) {
        // do not include internal parameters
        if (_parameters[_i].name.indexOf('mbox') !== 0) {
          _result[_result.length] = _parameters[_i].name + '=' + _parameters[_i].value;
        }
      }

      return _result;
    };

    /**
     * Sets the action to execute when the offer has loaded.
     * To be used with mboxUpdate.
     */
    mbox.prototype.setOnLoad = function (_action) {
      this._onLoad = _action;
      return this;
    };

    mbox.prototype.setMessage = function (_message) {
      this.message = _message;
      return this;
    };

    /**
     * @param _onError is a function that takes two string arguments:
     *   message, fetch type
     */
    mbox.prototype.setOnError = function (_onError) {
      this._onError = _onError;
      return this;
    };

    mbox.prototype.setFetcher = function (_fetcher) {
      if (this._contentFetcher) {
        this._contentFetcher.cancel();
      }
      this._contentFetcher = _fetcher;
      return this;
    };

    mbox.prototype.getFetcher = function () {
      return this._contentFetcher;
    };

    function _fireRequest(_urlBuilder, _mbox) {
      var _context = TNT._internal,
          _settings = _context._settings,
          _mboxTimeout = _settings.mboxTimeout;

      if (_context._isVisitorApiAvailable() && _context._isMarketingCloudDataAvailable()) {
        _urlBuilder.addParameters(_context._getMarketingCloudData());
      }

      _mbox._contentFetcher.fetch(_urlBuilder);

      _mbox._timer = setTimeout(function () {
        _mbox._onError('browser timeout', _mbox._contentFetcher.getType());
      }, _mboxTimeout);
    }

    function _showMbox(_mbox) {
      var _defaultDiv = _mbox.getDefaultDiv();

      if (_defaultDiv) {
        _mbox._showDiv(_mbox.getDefaultDiv());
      }
    }

    function _fireRequestAsync(_urlBuilder, _mbox, _optoutEnabled) {
      var _context = TNT._internal;

      _mbox.setFetcher(new mboxAjaxFetcher());

      _context._getMarketingCloudDataAsync(_optoutEnabled, function (_data) {
        if (_data === null) {
          _fireRequest(_urlBuilder, _mbox);
          return;
        }

        if (_optoutEnabled && _data.optout) {
          _showMbox(_mbox);
          return;
        }

        _urlBuilder.addParameters(_data.params);
        _fireRequest(_urlBuilder, _mbox);
      });
    }

    /**
     * Loads mbox content.
     * @param _parameters - Optional parameters to be added to the request.
     */
    mbox.prototype.load = function (_parameters) {
      var _self = this,
          _urlBuilder = _self._urlBuilder,
          _context = TNT._internal,
          _settings = _context._settings,
          _optoutEnabled = _settings.optoutEnabled;

      if (_self._contentFetcher === null) {
        return _self;
      }

      _self.cancelTimeout();
      _self._activated = 0;

      if (_parameters && _parameters.length > 0) {
        _urlBuilder = _self._urlBuilder.clone().addParameters(_parameters);
      }

      if (_optoutEnabled && _context._isVisitorApiAvailable()) {
        _fireRequestAsync(_urlBuilder, _self, _optoutEnabled);
        return _self;
      }

      var _isVisitorApiAvailable = _context._isVisitorApiAvailable();

      if (_isVisitorApiAvailable && !_context._isMarketingCloudDataAvailable()) {
        _fireRequestAsync(_urlBuilder, _self, false);
        return _self;
      }

      _fireRequest(_urlBuilder, _self);
      return _self;
    };

    /*
     * Used by the server to signal that all assets have been loaded by
     * the browser.
     */
    mbox.prototype.loaded = function () {
      this.cancelTimeout();

      // To avoid a runaway timer, we will try to activate ONLY a specific number of times
      if (!this.activate() && this._activateCount < this._maxActivateCount) {
        var _self = this;

        setTimeout(function () {
          _self.loaded();
        }, TNT._internal._settings.mboxLoadedTimeout);
      }
    };

    /**
     * Called when the mbox has been successfully loaded to activate
     * the mbox for display.
     *
     * This call may fail if the DOM has not been fully constructed
     */
    mbox.prototype.activate = function () {
      if (this._activated) {
        return this._activated;
      }

      if (this._waitForNestedMboxes && this._nestedMboxes[this._nestedMboxes.length - 1] !== this._name) {
        return this._activated;
      }

      if (this.show()) {
        this.cancelTimeout();
        this._activated = 1;
      }

      if (this._waitForNestedMboxes) {
        this._nestedMboxes.pop();
      }

      return this._activated;
    };

    /**
     * @return true if the mbox has been successfully activated
     */
    mbox.prototype.isActivated = function () {
      return this._activated;
    };

    /**
     * Sets an offer into mbox.
     *
     * @param _offer Offer object that must have 'show(mbox)' method which
     * will be called to render this offer within the mbox passed in.
     *
     * The offer.show() method should return 1 on success and 0 on error.
     */
    mbox.prototype.setOffer = function (_offer) {
      var _offerExists = _offer && _offer.show && _offer.setOnLoad;

      if (!_offerExists) {
        throw 'Invalid offer';
      }

      var _shouldCopyOnLoad = TNT._internal._settings.globalMboxName === this._name;
      _shouldCopyOnLoad = _shouldCopyOnLoad && _offer instanceof mboxOfferDefault;
      _shouldCopyOnLoad = _shouldCopyOnLoad && this._contentFetcher !== null;
      _shouldCopyOnLoad = _shouldCopyOnLoad && this._contentFetcher.getType() === 'ajax';

      if (!_shouldCopyOnLoad) {
        this._offer = _offer;

        return this;
      }

      // The _onLoad will be copied ONLY when we have global mbox,
      // the content fetcher is of type AJAX
      // and the offer to be set is of type mboxDefaultOffer
      // in all other cases we will use the normal flow
      var _onLoadFunc = this._offer._onLoad;
      this._offer = _offer;

      this._offer.setOnLoad(_onLoadFunc);

      return this;
    };

    mbox.prototype.getOffer = function () {
      return this._offer;
    };

    /**
     * Shows the offer.
     *
     * @return 1 if it was possible to show the content, 0 otherwise.
     */
    mbox.prototype.show = function () {
      /* WDPRO Additions */
      var target;
      /* End WDPRO Additions */

      var result = this._offer.show(this);

      /* WDPRO Additions */
      // if callback function exists then call it
      if ('function' == typeof mbox.mboxShowCallback) {
        mbox.mboxShowCallback(result);
      }

      //if there was a TnT failure, make sure the target div is reshown
      if (result !== 1) {
        var mboxName = this.getName();
        if (tnt_wdpro.aMboxTargets[mboxName] && tnt_wdpro.aMboxTargets[mboxName] !== '') {
          target = tnt_wdpro.getElement(tnt_wdpro.aMboxTargets[mboxName]);
          tnt_wdpro.showMboxTargetDivs(mboxName, target);
        }
      }
      /* End WDPRO Additions */

      return result;
    };

    /**
     * Shows the specified content in the mbox.
     *
     * @return Number 1 if it was possible to show the content, 0 otherwise.
     */
    mbox.prototype.showContent = function (_content) {
      if (!mbox._isContentAvailable(_content)) {
        return 0;
      }

      this._div = mbox._getMarkerDivIfRequired(this, this._div);

      if (this._div === null) {
        return 0;
      }

      if (!mbox._containsNode(document.body, this._div)) {
        return 0;
      }

      if (this._div === _content) {
        this._showDiv(this._div);
        this._onLoad();
        return 1;
      }

      this._hideDiv(this._div);
      this._hideDiv(_content);

      mbox._replaceDiv(this, _content);

      this._showDiv(this._div);
      this._onLoad();

      return 1;
    };

    mbox._isContentAvailable = function (_content) {
      return _content !== undefined && _content !== null;
    };

    mbox._containsNode = function (_parent, _child) {
      var DOCUMENT_POSITION_CONTAINED_BY = 16;
      var _containsMethodExists = _parent.contains !== undefined;

      // Node.contains() is available in IE and some versions of Safari
      // some versions of FireFox do not have support for Node.contains()
      if (_containsMethodExists) {
        return _parent !== _child && _parent.contains(_child);
      } else {
        // w3c DOM Level 3 should be available in all modern browsers
        return Boolean(_parent.compareDocumentPosition(_child) & DOCUMENT_POSITION_CONTAINED_BY);
      }
    };

    mbox._getMarkerDivIfRequired = function (_mbox, _div) {
      if (_div !== undefined && _div !== null && mbox._containsNode(document.body, _div)) {
        return _div;
      }

      return _mbox.getDefaultDiv();
    };

    mbox._replaceDiv = function (_mbox, _newDiv) {
      _mbox._div.parentNode.replaceChild(_newDiv, _mbox._div);
      _mbox._div = _newDiv;
    };

    /**
     * Hides any fetched content and show Default Content associated
     * with the mbox if it is avaliable yet.
     *
     * @return Number if it was possible to show the default content
     */
    mbox.prototype.hide = function () {
      return this.showContent(this.getDefaultDiv());
    };

    /**
     * Puts the mbox into a shown state, if that fails shows default content
     * Also cancels any timeouts associated with the mbox
     */
    mbox.prototype.finalize = function () {
      if (!this.getDefaultDiv()) {
        this._locator.force();
      }

      if (!this.getDiv()) {
        this._div = mbox._getMarkerDivIfRequired(this, this._div);
      }

      this._disableWaitForNestedMboxes();
      this.setFetcher(new mboxAjaxFetcher());
      this.cancelTimeout();
      this._onLoad();
    };

    mbox.prototype.cancelTimeout = function () {
      if (this._timer) {
        clearTimeout(this._timer);
      }

      if (this._contentFetcher) {
        this._contentFetcher.cancel();
      }
    };

    mbox.prototype.getDiv = function () {
      return this._div;
    };

    /**
     * returns valid default div
     * (even if it's not present in the DOM anymore)
     */
    mbox.prototype.getDefaultDiv = function () {
      if (this._defaultDiv === null) {
        this._defaultDiv = this._locator.locate();
      }
      return this._defaultDiv;
    };

    mbox.prototype.setEventTime = function (_event) {
      this._times[_event] = new Date().getTime();
    };

    mbox.prototype.getEventTimes = function () {
      return this._times;
    };

    mbox.prototype.getImportName = function () {
      return this._importName;
    };

    mbox.prototype.getURL = function () {
      return this._urlBuilder.buildUrl();
    };

    mbox.prototype.getUrlBuilder = function () {
      return this._urlBuilder;
    };

    mbox.prototype._isVisible = function (_div) {
      return _div.style.display != 'none';
    };

    mbox.prototype._showDiv = function (_div) {
      this._toggleDiv(_div, true);
    };

    mbox.prototype._hideDiv = function (_div) {
      this._toggleDiv(_div, false);
    };

    mbox.prototype._toggleDiv = function (_div, _visible) {
      _div.style.visibility = _visible ? "visible" : "hidden";
      _div.style.display = _visible ? "block" : "none";
    };

    mbox.prototype._disableWaitForNestedMboxes = function () {
      this._waitForNestedMboxes = false;
    };

    mbox.prototype.relocateDefaultDiv = function () {
      this._defaultDiv = this._locator.locate();
    };

    /**
     * Creates and updates mboxes.
     *
     * @param _server host of the mbox server e.g.mbox-test.dev.tt.omtrdc.net
     * @param _clientCode - client's code e.g. 'demo'
     * @param _factoryId - a unique string identifying this factory
     */

    function _finalize(_factory) {
      _factory.getMboxes().each(function (_mbox) {
        _mbox.finalize();
      });
    }

    mboxFactory = function mboxFactory(_server, _clientCode, _factoryId) {
      var _context = TNT._internal;
      var _settings = _context._settings;
      var _helper = _context._helper;
      var _cookies = _context._cookies;
      var _pageParams = _context._pageParams;
      var _constants = _context._constants;
      var _version = _settings.mboxVersion;

      this._pageLoaded = false;
      this._factoryId = _factoryId;
      this._mboxes = new mboxList();

      mboxFactories.put(_factoryId, this);

      // mboxIsSupported is a client defined function to test if mbox is supported
      // on this platform (defaults to just returning true)
      this._supported = _settings.mboxIsSupportedFunction() && typeof (window.attachEvent || document.addEventListener || window.addEventListener) != 'undefined';

      this._enabled = this._supported && mboxGetPageParameter(_pageParams._disable, true) === null;

      var _isDefaultFactory = _factoryId == _constants._defaultFactoryId;
      var _cookieName = _constants._cookieNamePrefix + (_isDefaultFactory ? '' : '-' + _factoryId);
      this._cookieManager = new mboxCookieManager(_cookieName, _settings.cookieDomainFunction());

      if (!_settings.crossDomainXOnly) {
        this._enabled = this._enabled && this._cookieManager.isEnabled();
      }

      this._enabled = this._enabled && _helper._isNull(this._cookieManager.getCookie(_cookies._disable)) && _helper._isNull(this._cookieManager.getCookie(_cookies._experienceManagerDisabled));

      if (this.isAdmin()) {
        this.enable();
      }

      this._listenForDomReady();
      this._mboxPageId = mboxGenerateId();
      this._mboxScreenHeight = mboxScreenHeight();
      this._mboxScreenWidth = mboxScreenWidth();
      this._mboxBrowserWidth = mboxBrowserWidth();
      this._mboxBrowserHeight = mboxBrowserHeight();
      this._mboxColorDepth = mboxScreenColorDepth();
      this._mboxBrowserTimeOffset = mboxBrowserTimeOffset();
      this._mboxSessionId = new mboxSession(this._mboxPageId, _pageParams._sessionId, _cookies._sessionId, _settings.sessionExpirationTimeout, this._cookieManager);

      var _pc = new mboxPC(_cookies._tntId, _settings.tntIdLifetime, this._cookieManager);

      this._mboxPCId = _settings.overrideMboxEdgeServer ? new _context._pcDecorator(_pc, this._cookieManager) : _pc;
      this._urlBuilder = new mboxUrlBuilder(_server, _clientCode);

      this._initGlobalParameters(this._urlBuilder, _isDefaultFactory, _version);

      this._pageStartTime = new Date().getTime();
      this._pageEndTime = this._pageStartTime;

      var _self = this;
      this.addOnLoad(function () {
        _self._pageEndTime = new Date().getTime();
      });

      if (this._supported) {
        // Checks that all mboxes have been successfully imported
        // and shows default content for any that failed
        this.addOnLoad(function () {
          _self._pageLoaded = true;

          _finalize(_self);

          TNT._internal.nestedMboxes = [];
        });

        if (this._enabled) {
          this.limitTraffic(_settings.trafficLevelPercentage, _settings.trafficDuration);
          this._makeDefaultContentInvisible();
          this._mboxSignaler = new mboxSignaler(this);
        } else {
          if (!_settings.isProduction) {
            if (this.isAdmin()) {
              if (!this.isEnabled()) {
                alert("mbox disabled, probably due to timeout\n" + "Reset your cookies to re-enable\n(this message will only appear in administrative mode)");
              } else {
                alert("It looks like your browser will not allow " + _settings.companyName + " to set its administrative cookie. To allow setting the" + " cookie please lower the privacy settings of your browser.\n" + "(this message will only appear in administrative mode)");
              }
            }
          }
        }
      }
    };

    /**
     * Forcibly sets new PC ID.
     * This method should be used when there is a better way to track
     * a site user than by PC ID.
     *
     * @param _forcedId New PC ID to set.
     */
    mboxFactory.prototype.forcePCId = function (_forcedId) {
      if (!TNT._internal._settings.clientTntIdSupport) {
        return;
      }

      if (this._mboxPCId.forceId(_forcedId)) {
        this._mboxSessionId.forceId(mboxGenerateId());
      }
    };

    /**
     * Allows the client to use their sessionId as the mbox sessionId. This
     * is useful if the client is required to preserve their id through their
     * site.
     *
     * @param sessionId for New session id.
     */
    mboxFactory.prototype.forceSessionId = function (_forcedId) {
      if (!TNT._internal._settings.clientSessionIdSupport) {
        return;
      }

      this._mboxSessionId.forceId(_forcedId);
    };

    /**
     * @return true if the factory is enabled. If factory is disabled, the mboxes
     * are still created but they show default content only.
     */
    mboxFactory.prototype.isEnabled = function () {
      return this._enabled;
    };

    /**
     * @return cause of mbox disabling
     */
    mboxFactory.prototype.getDisableReason = function () {
      return this._cookieManager.getCookie(TNT._internal._cookies._disable);
    };

    /**
     * @return true if the client's environment is supported (i.e. there's a way
     *   to access DOM elements via document.getElementById and event handling
     *   is supported)
     */
    mboxFactory.prototype.isSupported = function () {
      return this._supported;
    };

    /**
     * Disables the factory for the specified duration.
     *
     * @param _duration - duration in seconds (optional)
     * @param _cause - cause of disable (optional)
     */
    mboxFactory.prototype.disable = function (_duration, _cause) {
      if (typeof _duration == 'undefined') {
        _duration = 60 * 60;
      }

      if (typeof _cause == 'undefined') {
        _cause = 'unspecified';
      }

      if (!this.isAdmin()) {
        this._enabled = false;
        this._cookieManager.setCookie(TNT._internal._cookies._disable, _cause, _duration);
      }
    };

    mboxFactory.prototype.enable = function () {
      this._enabled = true;
      this._cookieManager.deleteCookie(TNT._internal._cookies._disable);
    };

    mboxFactory.prototype.isAdmin = function () {
      return document.location.href.indexOf(TNT._internal._pageParams._environment) != -1;
    };

    /**
     * Limits the traffic (by disabling the factory for certain users) to the given
     * level for the specified duration.
     */
    mboxFactory.prototype.limitTraffic = function (_level, _duration) {
      if (TNT._internal._settings.trafficLevelPercentage != 100) {
        if (_level == 100) {
          return;
        }

        var _enable = true;

        if (parseInt(this._cookieManager.getCookie(TNT._internal._cookies._trafficLevel)) != _level) {
          _enable = Math.random() * 100 <= _level;
        }

        this._cookieManager.setCookie(TNT._internal._cookies._trafficLevel, _level, _duration);

        if (!_enable) {
          this.disable(60 * 60, 'limited by traffic');
        }
      }
    };

    /**
     * Adds a function to be called with body onload.
     */
    mboxFactory.prototype.addOnLoad = function (_function) {

      // This extra checking is so that if there is a race, where addOnLoad
      // is called as the onload functions are being called, we'll detect this
      // and correctly call the passed in function exactly once, after the dom
      // has loaded.

      if (this.isDomLoaded()) {
        _function();
      } else {
        var _calledFunction = false;
        var _wrapper = function _wrapper() {
          if (_calledFunction) {
            return;
          }
          _calledFunction = true;
          _function();
        };

        this._onloadFunctions.push(_wrapper);

        if (this.isDomLoaded() && !_calledFunction) {
          _wrapper();
        }
      }
    };

    mboxFactory.prototype.getEllapsedTime = function () {
      return this._pageEndTime - this._pageStartTime;
    };

    mboxFactory.prototype.getEllapsedTimeUntil = function (_time) {
      return _time - this._pageStartTime;
    };

    /**
     * @return An mboxList object that contains the mboxes associated with this
     *   factory.
     */
    mboxFactory.prototype.getMboxes = function () {
      return this._mboxes;
    };

    /**
     * @param _mboxId the id of the mbox, defaults to 0 if not specified.
     *
     * @return mbox with the specified _mboxName and _mboxId.
     */
    mboxFactory.prototype.get = function (_mboxName, _mboxId) {
      return this._mboxes.get(_mboxName).getById(_mboxId || 0);
    };

    /**
     * Updates one or more mboxes with the name _mboxName
     *
     * @param _mboxName - name of the mbox
     * @param _parameters - array of 0 or more items of the form "name=value"
     *   (the values need to be escaped for inclusion in the url)
     */
    mboxFactory.prototype.update = function (_mboxName, _parameters) {
      var _context = TNT._internal,
          _params = _context._params;

      if (!this.isEnabled()) {
        return;
      }

      var _self = this;

      if (!this.isDomLoaded()) {
        this.addOnLoad(function () {
          _self.update(_mboxName, _parameters);
        });

        return;
      }

      if (this._mboxes.get(_mboxName).length() === 0) {
        throw "Mbox " + _mboxName + " is not defined";
      }

      this._mboxes.get(_mboxName).each(function (_mbox) {
        var _urlBuilder = _mbox.getUrlBuilder();

        _urlBuilder.addParameter(_params._page, mboxGenerateId());

        _self._addMboxParameters(_urlBuilder, _mboxName);

        _mbox.load(_parameters);
      });
    };

    /**
     * This is a dummy method that we'll have to remove, all the logic is now part of Visitor API plugin
     */
    mboxFactory.prototype.setVisitorIdParameters = function (_urlBuilder, _mboxName) {
      this._addMboxParameters(_urlBuilder, _mboxName);
    };

    /**
     * Creates an mbox called _mboxName.
     *
     * There is a small chance that an mbox with the same name is created after
     * we call update - we will ignore this chance.
     *
     * @param _mboxName - name of the mbox
     * @param _parameters - array of 0 or more items of the form "name=value"
     *   (the values need to be escaped for inclusion in the url)
     * @param _defaultNode - the DOM node that is the default content
     *                       the name of the DOM that is the default content
     *                       or is not specified, search bacwords for
     *                       mboxDefault class to use as default content
     */
    mboxFactory.prototype.create = function (_mboxName, _parameters, _defaultNode) {
      return this._createMbox(_mboxName, _parameters, _defaultNode);
    };

    /**
     * This method will be used ONLY in mboxDefine()
     *
     * @param _mboxName
     * @param _parameters
     * @param _defaultNode
     * @private
     */
    mboxFactory.prototype._define = function (_mboxName, _parameters, _defaultNode) {
      return this._createMbox(_mboxName, _parameters, _defaultNode);
    };

    mboxFactory.prototype._createMbox = function (_mboxName, _parameters, _defaultNode) {
      if (!this.isSupported()) {
        return null;
      }

      var _now = new Date();
      var _time = _now.getTime() - _now.getTimezoneOffset() * TNT._internal._constants._millisInMinute;
      var _urlBuilder = this._urlBuilder.clone();

      _urlBuilder.addParameter(TNT._internal._params._count, this._mboxes.length() + 1);
      _urlBuilder.addParameter(TNT._internal._params._time, _time);
      _urlBuilder.addParameters(_parameters);

      this._addMboxParameters(_urlBuilder, _mboxName);

      var _mboxId, _locator, _mbox;

      if (_defaultNode) {
        _locator = new mboxLocatorNode(_defaultNode);
      } else {
        if (this._pageLoaded) {
          throw 'The page has already been loaded, can\'t write marker';
        }

        _locator = new mboxLocatorDefault(this._getMboxMarkerDivId(_mboxName));
      }

      try {
        _mboxId = this._mboxes.get(_mboxName).length();
        _mbox = new mbox(_mboxName, _mboxId, _urlBuilder, _locator, this._getMboxImportDivId(_mboxName), this);

        if (this._enabled) {
          _mbox.setFetcher(this._pageLoaded ? new mboxAjaxFetcher() : new mboxStandardFetcher());
        }

        var _self = this;

        _mbox.setOnError(function (_message, _type) {
          _mbox.setMessage(_message);
          _mbox.activate();

          if (!_mbox.isActivated()) {
            _self.disable(TNT._internal._settings.mboxFactoryDisabledTimeout, _message);
            window.location.reload(false);
          }
        });

        this._mboxes.add(_mbox);
      } catch (_e) {
        this.disable();
        throw 'Failed creating mbox "' + _mboxName + '", the error was: ' + _e;
      }

      return _mbox;
    };

    mboxFactory.prototype._addTntIdIfExists = function (_urlBuilder) {
      var _tntId = this._mboxPCId.getId();

      if (_tntId) {
        _urlBuilder.addParameter(TNT._internal._params._tntId, _tntId);
      }
    };

    mboxFactory.prototype._addTargetPageParamsIfExists = function (_urlBuilder, _mboxName) {
      var _shouldAddParams = !TNT.isAutoCreateGlobalMbox() && TNT.getGlobalMboxName() === _mboxName;

      if (_shouldAddParams) {
        _urlBuilder.addParameters(TNT.getTargetPageParameters());
      }
    };

    mboxFactory.prototype._addSupplementalDataIfExists = function (_urlBuilder, _mboxName) {
      var _context = TNT._internal,
          _supplementalDataIdParam = _context._params._supplementalDataId,
          _supplementalDataId = _context._generateSupplementalDataId(_mboxName);

      // According to Visitor API folks we have to regenerate supplemental data ID
      // when mboxUpdate is invoked
      if (_supplementalDataId) {
        _urlBuilder.addParameter(_supplementalDataIdParam, _supplementalDataId);
      }
    };

    mboxFactory.prototype._addMarketingCloudDataIfExists = function (_urlBuilder) {
      var _context = TNT._internal;

      if (_context._isVisitorApiAvailable() && _context._isMarketingCloudDataAvailable()) {
        _urlBuilder.addParameters(_context._getMarketingCloudData());
      }
    };

    mboxFactory.prototype._addMboxParameters = function (_urlBuilder, _mboxName) {
      this._addTntIdIfExists(_urlBuilder);
      this._addTargetPageParamsIfExists(_urlBuilder, _mboxName);
      this._addSupplementalDataIfExists(_urlBuilder, _mboxName);
      this._addMarketingCloudDataIfExists(_urlBuilder, _mboxName);
    };

    mboxFactory.prototype.getCookieManager = function () {
      return this._cookieManager;
    };

    mboxFactory.prototype.getPageId = function () {
      return this._mboxPageId;
    };

    mboxFactory.prototype.getPCId = function () {
      return this._mboxPCId;
    };

    mboxFactory.prototype.getSessionId = function () {
      return this._mboxSessionId;
    };

    mboxFactory.prototype.getSignaler = function () {
      return this._mboxSignaler;
    };

    mboxFactory.prototype.getUrlBuilder = function () {
      return this._urlBuilder;
    };

    mboxFactory.prototype._getMboxDivSuffix = function (_mboxName) {
      return this._factoryId + '-' + _mboxName + '-' + this._mboxes.get(_mboxName).length();
    };

    mboxFactory.prototype._getMboxMarkerDivId = function (_mboxName) {
      return TNT._internal._constants._divMarkerPrefix + this._getMboxDivSuffix(_mboxName);
    };

    mboxFactory.prototype._getMboxImportDivId = function (_mboxName) {
      return TNT._internal._constants._divImportPrefix + this._getMboxDivSuffix(_mboxName);
    };

    mboxFactory.prototype._initGlobalParameters = function (_urlBuilder, _isDefaultFactory, _version) {
      _urlBuilder.addParameter(TNT._internal._params._host, document.location.hostname);
      _urlBuilder.addParameter(TNT._internal._params._page, this._mboxPageId);
      _urlBuilder.addParameter(TNT._internal._params._screenHeight, this._mboxScreenHeight);
      _urlBuilder.addParameter(TNT._internal._params._screenWidth, this._mboxScreenWidth);
      _urlBuilder.addParameter(TNT._internal._params._browserWidth, this._mboxBrowserWidth);
      _urlBuilder.addParameter(TNT._internal._params._browserHeight, this._mboxBrowserHeight);
      _urlBuilder.addParameter(TNT._internal._params._browserTimeOffset, this._mboxBrowserTimeOffset);
      _urlBuilder.addParameter(TNT._internal._params._screenColorDepth, this._mboxColorDepth);
      _urlBuilder.addParameter(TNT._internal._pageParams._sessionId, this._mboxSessionId.getId());

      if (!_isDefaultFactory) {
        _urlBuilder.addParameter(TNT._internal._params._mboxFactoryId, this._factoryId);
      }

      if (TNT._internal._settings.crossDomainEnabled) {
        _urlBuilder.addParameter(TNT._internal._params._crossDomain, TNT._internal._settings.crossDomain);
      }

      var _params = TNT.getClientMboxExtraParameters();

      if (_params) {
        _urlBuilder.addParameters(_params.split('&'));
      }

      _urlBuilder.setUrlProcessAction(function (_url) {
        if (TNT._internal._settings.passPageParameters) {
          _url += '&';
          _url += TNT._internal._params._url;
          _url += '=' + encodeURIComponent(document.location);

          var _referrer = encodeURIComponent(document.referrer);

          if (_url.length + _referrer.length < 2000) {
            _url += '&';
            _url += TNT._internal._params._referrer;
            _url += '=' + _referrer;
          }
        }

        _url += '&';
        _url += TNT._internal._params._mboxVersion;
        _url += '=' + _version;

        return _url;
      });
    };

    /**
     * Causes all mbox default content to not be displayed:
     */
    mboxFactory.prototype._makeDefaultContentInvisible = function () {
      document.write('<style>.' + TNT._internal._constants._divDefaultClass + ' { visibility:hidden; }</style>');
    };

    mboxFactory.prototype.isDomLoaded = function () {
      return this._pageLoaded;
    };

    mboxFactory.prototype._listenForDomReady = function () {
      if (this._onloadFunctions) {
        return;
      }

      this._onloadFunctions = [];

      var _self = this;
      (function () {
        var _eventName = document.addEventListener ? "DOMContentLoaded" : "onreadystatechange";
        var _loaded = false;
        var _ready = function _ready() {
          if (_loaded) {
            return;
          }
          _loaded = true;
          for (var i = 0; i < _self._onloadFunctions.length; ++i) {
            _self._onloadFunctions[i]();
          }
        };

        if (document.addEventListener) {
          document.addEventListener(_eventName, function () {
            document.removeEventListener(_eventName, arguments.callee, false);
            _ready();
          }, false);

          window.addEventListener("load", function () {
            document.removeEventListener("load", arguments.callee, false);
            _ready();
          }, false);
        } else if (document.attachEvent) {
          if (self !== self.top) {
            document.attachEvent(_eventName, function () {
              if (document.readyState === 'complete') {
                document.detachEvent(_eventName, arguments.callee);
                _ready();
              }
            });
          } else {
            var _checkScrollable = function _checkScrollable() {
              try {
                document.documentElement.doScroll('left');
                _ready();
              } catch (_domNotReady) {
                setTimeout(_checkScrollable, 13);
              }
            };
            _checkScrollable();
          }
        }

        if (document.readyState === "complete") {
          _ready();
        }
      })();
    };

    (function (_module) {
      function _disableExperienceManagerAndReload(_atObj, _cookieName, _duration, _cookieManager) {
        if (_atObj.targetJSLoaded) {
          return;
        }

        _cookieManager.setCookie(_cookieName, true, _duration);
        window.location.reload();
      }

      function _initExperienceManager(_settings, _cookies, _cookieManager) {
        var _AT_KEY = '_AT',
            _RETRY = 50,
            _cookieName = _cookies._experienceManagerDisabled,
            _duration = _settings.experienceManagerDisabledTimeout,
            _timeout = _settings.experienceManagerTimeout,
            _url = _settings.experienceManagerPluginUrl,
            _emptyFunc = function _emptyFunc(_actions) {},
            _dummyFunc = function _dummyFunc(_actions) {
          setTimeout(function () {
            window[_AT_KEY].applyWhenReady(_actions);
          }, _RETRY);
        };

        if (_AT_KEY in window) {
          return;
        }

        window[_AT_KEY] = {};

        if (_cookieManager.getCookie(_cookieName) !== 'true') {
          document.write('<scr' + 'ipt src="' + _url + '"><\/sc' + 'ript>');

          window[_AT_KEY].applyWhenReady = _dummyFunc;

          setTimeout(function () {
            _disableExperienceManagerAndReload(window[_AT_KEY], _cookieName, _duration, _cookieManager);
          }, _timeout);
        } else {
          window[_AT_KEY].applyWhenReady = _emptyFunc;
        }
      }

      _module._initExperienceManager = _initExperienceManager;
    })(TNT._internal);

    (function (_module, _internal, _helper, _settings, _params, _constants) {
      function _getGlobalMboxName() {
        return _settings.globalMboxName;
      }

      function _getGlobalMboxLocation() {
        return _settings.globalMboxLocationDomId;
      }

      function _isAutoCreateGlobalMbox() {
        return _settings.globalMboxAutoCreate;
      }

      function _getClientMboxExtraParameters() {
        return _settings.parametersFunction();
      }

      function _getMboxDefaultNode() {
        var _ELEMENT_NODE = 1,
            _nodes = document.getElementsByTagName('script'),
            _node = _nodes[_nodes.length - 1];

        while (_node) {
          if (_node.nodeType === _ELEMENT_NODE && _node.className === _constants._divDefaultClass) {
            return _node;
          }

          _node = _node.previousSibling;
        }

        return null;
      }

      function _mboxCreate(_factory, _mboxName, _params) {
        var _defaultNode, _mbox;

        if (_internal._isVisitorApiAvailable()) {
          _defaultNode = _getMboxDefaultNode();
          _mbox = _factory.create(_mboxName, _params, _defaultNode);
        } else {
          _mbox = _factory.create(_mboxName, _params);
        }

        if (_mbox && _factory.isEnabled()) {
          _mbox.load();
        }

        return _mbox;
      }

      function _mboxDefine(_factory, _defaultNode, _mboxName, _params) {
        return _factory._define(_mboxName, _params, _defaultNode);
      }

      function _mboxUpdate(_factory, _mboxName, _params) {
        _factory.update(_mboxName, _params);
      }

      function _mboxGetCookie(_cookieManager, _name) {
        return _cookieManager.getCookie(_name);
      }

      function _mboxSetCookie(_cookieManager, _name, _value, _duration) {
        _cookieManager.setCookie(_name, _value, _duration);
      }

      function _extractParamsFromQueryString(_queryString) {
        var _result = [];
        var _regex = /([^&=]+)=([^&]*)/g;
        var _decode = decodeURIComponent;
        var _match = _regex.exec(_queryString);

        while (_match) {
          _result.push([_decode(_match[1]), _decode(_match[2])].join('='));
          _match = _regex.exec(_queryString);
        }

        return _result;
      }

      function _extractParamsFromObject(_obj, _keys, _keyFunc) {
        var _result = [];

        for (var _key in _obj) {
          if (!_obj.hasOwnProperty(_key)) {
            continue;
          }

          var _value = _obj[_key];

          if (_helper._isObject(_value)) {
            _keys.push(_key);
            _result = _result.concat(_extractParamsFromObject(_value, _keys, _keyFunc));
            _keys.pop();
          } else {
            if (_keys.length > 0) {
              _result.push([_keyFunc(_keys.concat(_key).join('.')), _value].join('='));
            } else {
              _result.push([_keyFunc(_key), _value].join('='));
            }
          }
        }

        return _result;
      }

      function _getTargetPageParameters() {
        var _targetPageParams = window.targetPageParams,
            _keyFunc = function _keyFunc(_key) {
          return _key;
        };

        if (!_helper._isFunction(_targetPageParams)) {
          return [];
        }

        var _result = null;

        try {
          _result = _targetPageParams();
        } catch (_ignore) {}

        if (_helper._isNull(_result)) {
          return [];
        }

        if (_helper._isArray(_result)) {
          return _result;
        }

        if (_helper._isString(_result) && !_helper._isEmpty(_result)) {
          return _extractParamsFromQueryString(_result);
        }

        if (_helper._isObject(_result)) {
          return _extractParamsFromObject(_result, [], _keyFunc);
        }

        return [];
      }

      function _createGlobalMbox(_factory) {
        var _globalMboxName = _getGlobalMboxName(),
            _globalMboxDomElementId = _getGlobalMboxLocation(),
            _globalParams = _getTargetPageParameters(),
            _globalMboxDiv,
            _timerId,
            _globalMbox;

        if (!_globalMboxDomElementId) {
          _globalMboxDomElementId = "mbox-" + _globalMboxName + "-" + mboxGenerateId();
          _globalMboxDiv = document.createElement("div");
          _globalMboxDiv.className = "mboxDefault";
          _globalMboxDiv.id = _globalMboxDomElementId;
          _globalMboxDiv.style.visibility = "hidden";
          _globalMboxDiv.style.display = "none";

          _timerId = setInterval(function () {
            if (document.body) {
              clearInterval(_timerId);
              document.body.insertBefore(_globalMboxDiv, document.body.firstChild);
            }
          }, _settings.bodyPollingTimeout);
        }

        _globalMbox = _factory.create(_globalMboxName, _globalParams, _globalMboxDomElementId);

        if (_globalMbox && _factory.isEnabled()) {
          if (!_factory.isDomLoaded()) {
            if (!_internal._isVisitorApiAvailable()) {
              _globalMbox.setFetcher(new _internal._globalMboxFetcher());
            } else if (_internal._isMarketingCloudDataAvailable()) {
              _globalMbox.setFetcher(new _internal._globalMboxFetcher());
            } else {
              _globalMbox.setFetcher(new mboxAjaxFetcher());
            }
          }

          _globalMbox.load();
        }
      }

      function _mboxVizTargetUrl(_factory, _mboxName, _parameters) {
        if (!_factory.isEnabled()) {
          return;
        }

        var _now = new Date(),
            _offset = _now.getTimezoneOffset() * _constants._millisInMinute,
            _urlBuilder = _factory.getUrlBuilder().clone();

        _urlBuilder.setBasePath('/m2/' + _settings.clientCode + '/viztarget');
        _urlBuilder.addParameter(_params._mboxName, _mboxName);
        _urlBuilder.addParameter(_params._mboxId, 0);
        _urlBuilder.addParameter(_params._count, _factory.getMboxes().length() + 1);
        _urlBuilder.addParameter(_params._time, _now.getTime() - _offset);
        _urlBuilder.addParameter(_params._page, mboxGenerateId());
        _urlBuilder.addParameter(_params._domLoaded, _factory.isDomLoaded());

        if (_parameters && _parameters.length > 0) {
          _urlBuilder.addParameters(_parameters);
        }

        _factory._addTntIdIfExists(_urlBuilder);
        _factory._addTargetPageParamsIfRequired(_urlBuilder, _mboxName);
        _factory._addSupplementalDataIfExists(_urlBuilder, _mboxName);

        return _urlBuilder.buildUrl();
      }

      function _createMboxFactories() {
        return new mboxMap();
      }

      function _createMboxFactory(_serverHost, _clientCode, _factoryId) {
        return new mboxFactory(_serverHost, _clientCode, _factoryId);
      }

      // internally exported
      _internal._mboxCreate = _mboxCreate;
      _internal._mboxDefine = _mboxDefine;
      _internal._mboxUpdate = _mboxUpdate;
      _internal._mboxVizTargetUrl = _mboxVizTargetUrl;
      _internal._mboxGetCookie = _mboxGetCookie;
      _internal._mboxSetCookie = _mboxSetCookie;
      _internal._createGlobalMbox = _createGlobalMbox;
      _internal._createMboxFactories = _createMboxFactories;
      _internal._createMboxFactory = _createMboxFactory;
      _internal._extractParamsFromObject = _extractParamsFromObject;

      // globally exported
      _module.getGlobalMboxName = _getGlobalMboxName;
      _module.getGlobalMboxLocation = _getGlobalMboxLocation;
      _module.isAutoCreateGlobalMbox = _isAutoCreateGlobalMbox;
      _module.getClientMboxExtraParameters = _getClientMboxExtraParameters;
      _module.getTargetPageParameters = _getTargetPageParameters;
    })(TNT, TNT._internal, TNT._internal._helper, TNT._internal._settings, TNT._internal._params, TNT._internal._constants);

    (function (_module) {
      function _showDebugInfoIfRequired(_cookieManager, _settings, _debugParam, _debugCookie) {
        var _DEBUG_TIMEOUT = 60 * 60,
            _isDebugEnabled = mboxGetPageParameter(_debugParam, true) || _cookieManager.getCookie(_debugCookie);

        if (!_isDebugEnabled) {
          return;
        }

        setTimeout(function () {
          if (typeof window.mboxDebugLoaded === 'undefined') {
            alert('Could not load the remote debug.\nPlease check your connection to ' + _settings.companyName + ' servers');
          }
        }, _DEBUG_TIMEOUT);

        var _parts = [];

        _parts.push(_settings.adminUrl, '/mbox/mbox_debug.jsp', '?');
        _parts.push('mboxServerHost', '=', _settings.serverHost, '&');
        _parts.push('clientCode', '=', _settings.clientCode);

        document.write('<' + 'scr' + 'ipt src="' + _parts.join('') + '"><' + '\/scr' + 'ipt>');
      }

      function _copySettingsIfExists(_settings, _internalSettings) {
        var _helper = _module._helper,
            _keyExists,
            _valueExists,
            _value;

        if (_helper._isUndefined(_settings) || _helper._isNull(_settings) || !_helper._isObject(_settings)) {
          return _internalSettings;
        }

        for (var _key in _settings) {
          _keyExists = _settings.hasOwnProperty(_key) && _internalSettings.hasOwnProperty(_key);
          _value = _settings[_key];
          _valueExists = !_helper._isUndefined(_value) && !_helper._isNull(_value);

          if (_keyExists && _valueExists) {
            _internalSettings[_key] = _value;
          }
        }

        return _internalSettings;
      }

      function _exportGlobals(_factory, _cookieManager) {
        TNT.createGlobalMbox = function () {
          _module._createGlobalMbox(_factory);
        };

        window.mboxCreate = function (_mboxName /*, ...*/) {
          var _params = [].slice.call(arguments, 1);

          return _module._mboxCreate(_factory, _mboxName, _params);
        };

        window.mboxDefine = function (_defaultNode, _mboxName /*, ...*/) {
          var _params = [].slice.call(arguments, 2);

          return _module._mboxDefine(_factory, _defaultNode, _mboxName, _params);
        };

        window.mboxUpdate = function (_mboxName /*, ...*/) {
          var _params = [].slice.call(arguments, 1);

          _module._mboxUpdate(_factory, _mboxName, _params);
        };

        window.mboxVizTargetUrl = function (_mboxName /*, ...*/) {
          var _params = [].slice.call(arguments, 1);

          return _module._mboxVizTargetUrl(_factory, _mboxName, _params);
        };

        window.mboxSetCookie = function (_name, _value, _duration) {
          return _module._mboxSetCookie(_cookieManager, _name, _value, _duration);
        };

        window.mboxGetCookie = function (_name) {
          return _module._mboxGetCookie(_cookieManager, _name);
        };

        // In case SiteCatalyst integration is not enabled we should not
        // export the mboxLoadSCPlugin function
        if (typeof _module._mboxLoadSCPlugin !== 'undefined') {
          window.mboxLoadSCPlugin = function (_siteCatalystCore) {
            return _module._mboxLoadSCPlugin(_factory, _siteCatalystCore);
          };
        }
      }

      function _bootstrap() {
        if (typeof window.mboxVersion !== 'undefined') {
          return;
        }

        _module._settings = _copySettingsIfExists(window.targetGlobalSettings, _module._settings);

        var _settings = _module._settings,
            _version = _settings.mboxVersion,
            _serverHost = _settings.serverHost,
            _clientCode = _settings.clientCode,
            _defaultFactoryId = _module._constants._defaultFactoryId,
            _debugParam = _module._pageParams._debug,
            _debugCookie = _module._cookies._debug,
            _mboxEdgeServerCookie = _module._cookies._mboxEdgeServer,
            _factory,
            _cookieManager;

        // We should expose these variables to make sure other JS parts have access to them
        window.mboxFactories = _module._createMboxFactories();
        window.mboxFactoryDefault = _factory = _module._createMboxFactory(_serverHost, _clientCode, _defaultFactoryId);
        window.mboxVersion = _version;

        _cookieManager = _factory.getCookieManager();

        _exportGlobals(_factory, _cookieManager);
        _showDebugInfoIfRequired(_cookieManager, _settings, _debugParam, _debugCookie);

        _module._getMboxEdgeServer = function (_mboxServerDefaultValue) {
          var _mboxServer;

          if (!_settings.overrideMboxEdgeServer) {
            return _mboxServerDefaultValue;
          }

          _mboxServer = _cookieManager.getCookie(_mboxEdgeServerCookie);

          return _mboxServer === null ? _mboxServerDefaultValue : _mboxServer;
        };
      }

      _module._bootstrap = _bootstrap;
    })(TNT._internal);

    TNT._internal._bootstrap();

    TNT._internal._initExperienceManager(TNT._internal._settings, TNT._internal._cookies, window.mboxFactoryDefault.getCookieManager());
    /*mboxTrack() & mboxTrackLink() & mboxTrackDefer() v4 ==>Mbox.js Extra Javascript*/var mboxTrack = function mboxTrack(mbox, params) {
      var m,
          u,
          i,
          f = mboxFactoryDefault;if (f.isEnabled()) {
        if (f.getMboxes().length() > 0) {
          m = f.getMboxes().getById(0);u = m.getURL().replace("mbox=" + escape(m.getName()), "mbox=" + mbox).replace("/undefined", "/ajax").replace("mboxPage=" + f.getPageId(), "mboxPage=" + mboxGenerateId()) + '&' + params, i = new Image();i.style.display = 'none';i.src = u;document.body.appendChild(i);
        } else {
          mboxTrackDefer(mbox, params);
        }
      }
    },
        mboxTrackDefer = function mboxTrackDefer(mbox, params) {
      var f = mboxFactoryDefault;if (f.isEnabled()) {
        mboxFactoryDefault.getSignaler().signal(mbox, mbox + '&' + params);
      }
    },
        mboxTrackLink = function mboxTrackLink(mbox, params, url) {
      mboxTrack(mbox, params);setTimeout("location='" + url + "'", 500);
    };

    if (TNT.isAutoCreateGlobalMbox()) {
      TNT.createGlobalMbox();
    }

    [["_finalize", _finalize], ["_fireRequest", _fireRequest], ["_fireRequestAsync", _fireRequestAsync], ["_showMbox", _showMbox], ["mboxCopyright", mboxCopyright], ["mboxTrack", mboxTrack], ["mboxTrackDefer", mboxTrackDefer], ["mboxTrackLink", mboxTrackLink], ["TNT", TNT], ["tnt_wdpro", tnt_wdpro]].forEach(function (arr) {
      window[arr[0]] = arr[1];
    });
  })();
})(window, document, location);
//# sourceMappingURL=framework-top.js.map
